import { Component, OnInit, ViewEncapsulation, ViewChild, ChangeDetectorRef, Renderer2, inject, OnDestroy, Input } from '@angular/core';
import { InvoiceErrorCode } from '../shared/enums/InvoiceErrorCode';
import { Subscription, throwError } from 'rxjs';
import { GlobalsService } from '../shared/services/globals.service';
import { BaseDQOIComponent } from '../shared/base-components/base-dqoi.component';
import { InvoiceBus } from '../shared/models/InvoiceBus';
import { InvoiceService } from '../shared/services/invoice.service';
import { DQOIService } from '../shared/services/DQOI.service';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { AdditionalInvoiceData } from '../shared/models/AdditionalInvoiceData';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonFunctions } from '../shared/static/common-functions';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { GItem } from '../shared/models/GItem';
import { Address } from '../shared/models/Address';
import { CustomerService } from '../shared/services/customer.service';
import { InvoicePage } from '../shared/models/InvoicePage';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { DateFunctions } from '../shared/static/date-functions';
import { v_LocationDetailBus } from '../shared/models/v_LocationDetailBus';
import { GeographyInfoBus } from '../shared/models/GeographyInfoBus';
import { InvoiceInfo } from '../shared/models/InvoiceInfo';
import * as _ from 'lodash';
import { DQOIItem } from '../shared/models/DQOIItem';
import { BaseMessageInfo } from '../shared/models/BaseMessageInfo';
import { CDocument } from '../shared/models/CDocument';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from '@progress/kendo-file-saver';
import { SaveMode } from '../shared/enums/SaveMode';
import { InvoiceMessageInfo } from '../shared/models/InvoiceMessageInfo';
import { InvoiceAttachmentsComponent } from './attachments/invoice-attachments.component';
import { InvoiceLineItemsComponent } from './invoice-lineitems/invoice-lineitems.component';
import { InvoiceNotesComponent } from './invoice-notes/invoice-notes.component';
import { InvoiceEquipmentComponent } from './equipment/invoice-equipment.component';
import { InvoiceCheckListBus } from '../shared/models/InvoiceCheckListBus';
import { CommonValues } from '../shared/static/CommonValues';
import { CRUDActions } from '../shared/enums/CRUDActions';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { ScheduleInvoicesComponent } from './scheduled/schedule-invoices.component';
import { InvoiceChecklistComponent } from './invoice-checklist/invoice-checklist.component';
import { DQOIParam } from '../shared/models/DQOIParam';
import { InvoiceSaveParam } from '../shared/models/InvoiceSaveParam';
import { CommonParam } from '../shared/models/CommonParam';
import { Profit } from '../shared/models/Profit';
import { CommonAppStates } from '../shared/enums/CommonAppStates';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { TaxCodeBus } from '../shared/models/TaxCodeBus';
import { InvoicePaymentsComponent } from './payments/invoice-payments.component';
import { TaxCodeComponent } from '../shared/components/tax-code/tax-code.component';
import { CollectionNotesComponent } from './collection-notes/collection-notes.component';
import { InvoiceNoteBus } from '../shared/models/InvoiceNoteBus';
import { MessageType } from '../shared/enums/MessageType';
import { InvoicePickerComponent } from '../dispatches/invoice-picker/invoice-picker.component';
import { QuotePickerComponent } from './quote-picker/quote-picker.component';
import { Message } from '../shared/models/message';
import { AppCategory } from '../shared/enums/AppCategories';
import { InvoiceCopytoNewComponent } from './invoice-copyto-new/invoice-copyto-new.component';
import { Router } from '@angular/router';
import { MessageInfo } from '../shared/models/MessageInfo';
import { Email } from '../shared/models/Email';
import { InvoiceDisputeCMComponent } from './Invoice-dispute-cm/invoice-dispute-cm.component';
import { CreditMemoCORRComponent } from './credit-memo-corr/credit-memo-corr.component';
import { CPSearchComponent } from '../shared/search/cp-search/cp-search.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { AuthenticationService } from '../shared/services/authentication.service';
import { ConstructionCredits } from '../shared/enums/ConstructionCredits';
import { ConstructionCredit } from '../shared/models/ConstructionCredit';
import { PrintService } from '../shared/services/print.service';
import { UseCPLoader, ICPLoader } from '../shared/decorators/cploader/cploader-decorator';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { DQOIInvoiceDisplaySettings } from '../shared/models/DQOIDisplaySettings';
import { PdfResponse } from '../shared/models/PdfResponse';
import { InvoiceNumberCheckResponse } from '../shared/models/InvoiceNumberCheckResponse';
import { AppClaims } from '../shared/models/AppClaims';

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvoicesComponent extends BaseDQOIComponent<InvoiceBus, InvoiceService, AdditionalInvoiceData, InvoicePage> implements OnInit, OnDestroy {
    @ViewChild("quotePicker") quotePicker: QuotePickerComponent;
    @ViewChild("invoicePicker") invoicePicker: InvoicePickerComponent;
    @ViewChild("LineItems") invoiceLineItemsComponent: InvoiceLineItemsComponent;
    @ViewChild("Notes") invoiceNotesComponent: InvoiceNotesComponent;
    @ViewChild("Attachments") invoiceAttachmentsComponent: InvoiceAttachmentsComponent;
    @ViewChild("CollNotes") collectionNotesComponent: CollectionNotesComponent;
    @ViewChild("Equipment") invoiceEquipmentComponent: InvoiceEquipmentComponent;
    @ViewChild("ScheduleInvoices") scheduleInvoicesComponent: ScheduleInvoicesComponent;
    @ViewChild("CheckList") invoiceChecklistComponent: InvoiceChecklistComponent;
    @ViewChild("InvoicePayments") invoicePaymentsComponent: InvoicePaymentsComponent;
    @ViewChild("TaxCode") taxCodeComponent: TaxCodeComponent;
    @ViewChild("invCopyToNew") invCopyToNewComponent: InvoiceCopytoNewComponent;
    @ViewChild("invoiceDisputeCM") invoiceDisputeCMComponent: InvoiceDisputeCMComponent;
    @ViewChild("invoiceDisputeCMTab") invoiceDisputeCMTabComponent: InvoiceDisputeCMComponent;
    @ViewChild("invoiceDisputeCMCollTab") invoiceDisputeCMCollTabComponent: InvoiceDisputeCMComponent;
    @ViewChild("CMCORR") creditMemoCORRComponent: CreditMemoCORRComponent;
    @ViewChild("CollNoteDispute") collectionNoteDispComponent: CollectionNotesComponent;
    @ViewChild('cpSearchDispatchs') CpSearchDispatchs: CPSearchComponent;
    compFeatureFlagSet: IFeatureFlagSet = this as any;

    @Input() dqoiInvoiceDisplaySettings: DQOIInvoiceDisplaySettings = new DQOIInvoiceDisplaySettings();

    compLoader: ICPLoader = this as any;
    private tabSelected: string;
    appState: any;
    billToAddress: Address = new Address();
    appCode: string = "Invoice";
    count: number;
    popUp: boolean = false;
    avalaraTaxStatus: string;
    isFetchFromAvalaraLabel: boolean = false;
    isAvalaraTaxCodeInfo: boolean = false;
    aMNoteAdjusted: boolean = false;
    inOracleError: boolean = false;
    laborInventoryLocationIds: string[];
    isWarranty: any;
    divisionInventoryLocationId: string;
    subs_statusUpdate: Subscription;
    subs_resendOracle: Subscription;
    InvoiceChecklist: InvoiceCheckListBus[];
    blockStatusChange = false;

    private defaultConstructionCreditObject = new ConstructionCredit(ConstructionCredits.None, false, null, null, ``, ``);
    private constructionCreditObject = { ...this.defaultConstructionCreditObject };
    private hasCreateConstructionCreditsPermission: boolean = false;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService, private svc_customer: CustomerService, private sanitizer: DomSanitizer, private cd: ChangeDetectorRef, renderer2: Renderer2, private router: Router, private svc_auth: AuthenticationService, private printService: PrintService) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.renderer = renderer2;
        this.addtlDataClass = "AdditionalInvoiceData";
        this.searchTarget = SearchTarget.invoice;
        this.pageData = new InvoicePage(svc_data, null, cd);
        this.saveMode = SaveMode.all;
        this.callTrySave = true;
        this.setupCheckForm();
        this.invoiceDisputeValue = this.InvoiceDispute;
    }

    reduceToMinData() { }
    taxCodeData = [];

    override ngOnInit(): void {
        super.ngOnInit();
        this.checkUserForConstructionCreditsPermission();
    }

    override parentMessage(e: Message, cpLoader: ICPLoader) {
        if (e.messageType === MessageType.pricesCleared) {
            //We dont use customParentMessage here cause we need to pass the message to the parent
            this.pricesCleared(e.value);
            e.messageType = MessageType.changed;
            super.parentMessage(e, cpLoader);
            return;
        }
        else if (e.messageType === MessageType.aggregateResultsUpdated) {
            this.getProfit();
            return;
        }
        else if (e.messageType === MessageType.setPristine) {
            this.setPristine();
            return;
        }
        else if (e.messageType === MessageType.refresh && e.messageSubject === "VendorBackup") {
            if (this.data?.invoiceId) {
                this.pageData.getAttachments(this.data.invoiceId);
            }
            return;
        }
        super.parentMessage(e, cpLoader);
    }

    private pricesCleared(changedData: any) {
        if (!changedData) {
            return;
        }

        //need to sync the data
        if (this.data) {
            this.data.saleMaterial = changedData.saleMaterial;
            this.data.saleLabor = changedData.saleLabor;
            this.data.saleOther = changedData.saleOther;
            this.data.taxAmount = changedData.taxAmount;
            this.data.amount = changedData.amount;
            this.data.total = changedData.total;
        }
        this.editForm.patchValue({
            saleMaterial: changedData.saleMaterial,
            saleLabor: changedData.saleLabor,
            saleOther: changedData.saleOther,
            total: changedData.total,
            taxAmount: changedData.taxAmount,
            amount: changedData.amount,
        });
    }

    protected cancelChildren(): void {
        super.cancelChildren();
        if (this.isConstruction && this.compFeatureFlagSet.featureFlagSet['credit-memo-invoice-copy']) {
            this.constructionCreditObject.constructionCreditType = ConstructionCredits.None;
            this.constructionCreditObject.reloadInvoiceId = ``;
            this.constructionCreditObject.data = null;
            this.constructionCreditObject.addtlData = null;
            this.constructionCreditObject.hasSavedCreditMemo = false;
        }
    }

    taxCodesCanSelectAndCurrent(taxCodeId) {
        this.taxCodeData = [];
        if (this.referenceData.taxCodes) {
            this.referenceData?.taxCodes.forEach(e => {
                if (e.canSelect) {
                    this.taxCodeData.push(e);
                }
            });
            const item = this.referenceData?.taxCodes.find(e => e.value === taxCodeId);
            if (item) {
                if (!this.taxCodeData.find(e => e == item)) {
                    this.taxCodeData.push(item);
                }
            }
        }
        return this.taxCodeData;
    }

    customReferenceData() {
        this.taxCodesCanSelectAndCurrent(this.data?.taxCodeId);
    }

    formatGatewaySubmitDate(date: Date): string {
        if (!date) {
            return "";
        }

        return new Intl.DateTimeFormat("en-US", {
            month: "numeric",
            day: "numeric",
            year: "2-digit",
            hour: "numeric",
            minute: "2-digit",
            timeZoneName: "short"
        }).format(date);
    }

    subs_dataScheduledInvoices: Subscription;
    subs_dataDuplicateInvoice: Subscription;
    subs_dataCustExcel: Subscription;
    subs_dataMergedDocs: Subscription;
    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'invoiceId': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'customerId': new UntypedFormControl('', Validators.required),
        'locationId': new UntypedFormControl('', Validators.required),
        'invoiceStatusId': new UntypedFormControl('', Validators.required),
        'salespersonId': new UntypedFormControl(''),
        'billingGeographyId': new UntypedFormControl(),
        'shippingGeographyId': new UntypedFormControl(),
        'quoteId': new UntypedFormControl(),
        'dispatchId': new UntypedFormControl(),
        'accountClassId': new UntypedFormControl('', Validators.required),
        'invoiceDate': new UntypedFormControl('', Validators.required),
        'invoiceNumber': new UntypedFormControl(),
        'ponumber': new UntypedFormControl(),
        'invoiceDesc': new UntypedFormControl(),
        'qbid': new UntypedFormControl(),
        'qbEditSequenceId': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'taxCodeId': new UntypedFormControl(CommonValues.Avalara_TaxCode, Validators.required),
        'taxAmount': new UntypedFormControl(),
        'termId': new UntypedFormControl('', Validators.required),
        'wonumber': new UntypedFormControl(),
        'vendorNumber': new UntypedFormControl(),
        'oldDate': new UntypedFormControl(),
        'commissionDate': new UntypedFormControl(),
        'commissionAmount': new UntypedFormControl(null as number),
        'cost': new UntypedFormControl(null as number),
        'costMaterial': new UntypedFormControl(null as number),
        'costLabor': new UntypedFormControl(null as number),
        'saleMaterial': new UntypedFormControl(null as number),
        'saleLabor': new UntypedFormControl(null as number),
        'amount': new UntypedFormControl(null as number),
        'total': new UntypedFormControl(null as number),
        'pooverrideUserId': new UntypedFormControl(),
        'costOther': new UntypedFormControl(null as number),
        'saleOther': new UntypedFormControl(null as number),
        'minProfitOverrideUserId': new UntypedFormControl(),
        'minProfitOverrideDt': new UntypedFormControl(),
        'sageDt': new UntypedFormControl(),
        'billingStreet': new UntypedFormControl(),
        'billingCityStateZip': new UntypedFormControl(),
        'dispatchNumber': new UntypedFormControl(),
        'dispatchDate': new UntypedFormControl(),
        'profit': new UntypedFormControl(),
        'profitPct': new UntypedFormControl(),
        'callbackNumber': new UntypedFormControl(),
        'quoteNumber': new UntypedFormControl(),
        'notToExceed': new UntypedFormControl(),
        'refTrackNbr': new UntypedFormControl(),
        'disputeStatus': new UntypedFormControl(),
        'showDispatchNumberOnLineItems': new UntypedFormControl(),
        'taxCode': new UntypedFormControl(),
        'amNote': new UntypedFormControl(),
        'useTax': new UntypedFormControl(),
        'taxTypeCode': new UntypedFormControl(),
        'isAvalara': new UntypedFormControl(),
        'orderBillId': new UntypedFormControl(),
        'orderBillReferenceNumber': new UntypedFormControl()
    });

    setForm() {
        this.editForm.patchValue({
            invoiceId: this.data.invoiceId,
            companyId: this.data.companyId,
            customerId: this.data.customerId,
            locationId: this.data.locationId,
            invoiceStatusId: this.data.invoiceStatusId,
            salespersonId: this.data.salespersonId,
            billingGeographyId: this.data.billingGeographyId,
            shippingGeographyId: this.data.shippingGeographyId,
            quoteId: this.data.quoteId,
            dispatchId: this.data.dispatchId,
            accountClassId: this.data.accountClassId,
            invoiceDate: this.data.invoiceDate,
            invoiceNumber: this.data.invoiceNumber,
            ponumber: this.data.ponumber,
            invoiceDesc: this.data.invoiceDesc,
            qbid: this.data.qbid,
            qbEditSequenceId: this.data.qbEditSequenceId,
            insertDt: this.data.insertDt,
            insertUserId: this.data.insertUserId,
            updateDt: this.data.updateDt,
            updateUserId: this.data.updateUserId,
            taxCodeId: this.data.taxCodeId ? this.data.taxCodeId : CommonValues.Avalara_TaxCode,
            taxAmount: this.data.taxAmount,
            termId: this.data.termId,
            wonumber: this.data.wonumber,
            vendorNumber: this.data.vendorNumber,
            oldDate: this.data.oldDate,
            commissionDate: this.data.commissionDate,
            commissionAmount: this.data.commissionAmount,
            cost: this.data.cost,
            costMaterial: this.data.costMaterial,
            costLabor: this.data.costLabor,
            saleMaterial: this.data.saleMaterial,
            saleLabor: this.data.saleLabor,
            amount: this.data.amount,
            total: this.data.total,
            pooverrideUserId: this.data.pooverrideUserId,
            costOther: this.data.costOther,
            saleOther: this.data.saleOther,
            minProfitOverrideUserId: this.data.minProfitOverrideUserId,
            minProfitOverrideDt: this.data.minProfitOverrideDt,
            disputeStatus: this.data.disputeStatus,
            sageDt: this.data.sageDt,
            showDispatchNumberOnLineItems: this.data.showDispatchNumberOnLineItems,
            amNote: this.data.amNote,
            useTax: this.data.useTax,
            taxTypeCode: this.data.taxTypeCode,
            isAvalara: this.data.isAvalara,
            orderBillId: this.data.orderBillId,
            orderBillReferenceNumber: this.data.orderBillReferenceNumber,
        });
        this.setNewButtonTypeData();
    }

    setFormAddtl() {
        let costPlusUseTax = this.getCostPlusUseTax();
        this.editForm.patchValue({
            billingStreet: this.billToAddress.addressLine1,
            billingCityStateZip: this.billToAddress.cityStateZip,
            dispatchNumber: this.addtlData.detail.dispatchNumber,
            dispatchDate: this.addtlData.detail.dispatchDate,
            callbackNumber: this.addtlData.detail.callbackNumber,
            quoteNumber: this.addtlData.detail.quoteNumber,
            notToExceed: this.addtlData.detail.notToExceed,
            refTrackNbr: this.addtlData.detail.refTrackNbr,
            profit: CommonFunctions.formatMoney(CommonFunctions.calculateProfit(costPlusUseTax, this.data.amount)),
            profitPct: CommonFunctions.formatPct(CommonFunctions.calculateProfitPct(costPlusUseTax, this.data.amount))
        });
        this.getProfit();
    }

    setFormTotalSummary() {
        this.editForm.patchValue({
            cost: this.data.cost,
            costMaterial: this.data.costMaterial,
            costLabor: this.data.costLabor,
            saleMaterial: this.data.saleMaterial,
            saleLabor: this.data.saleLabor,
            amount: this.data.amount,
            total: this.data.total,
            costOther: this.data.costOther,
            saleOther: this.data.saleOther
        });
    }

    getCostPlusUseTax(): number {
        let costPlusUseTax: number = 0;
        if (this.hasData && this.hasAddtlData) {
            let cost: number = CommonFunctions.getNumberValue(this.data.cost);
            costPlusUseTax = cost;
            if (this.data.taxTypeCode == 2) {
                if (this.data.isAvalara) {
                    costPlusUseTax = cost + CommonFunctions.getNumberValue(this.data.useTax);
                }
                else if (this.hasAddtlData) {
                    costPlusUseTax = cost + CommonFunctions.getNumberValue(this.addtlData.profit.useTax);
                }
            }
        }
        return costPlusUseTax;
    }
    setFormLocation(data: v_LocationDetailBus) {

        this.editForm.patchValue({
            billingGeographyId: data.billingGeographyId,
            shippingGeographyId: data.geographyId,
            termId: data.termId,
            salespersonId: data.salespersonId,
            taxCodeId: data.taxCodeId
        });
    }
    setFormLocationNoTax(data: v_LocationDetailBus) {
        this.editForm.patchValue({
            billingGeographyId: data.billingGeographyId,
            shippingGeographyId: data.geographyId,
            termId: data.termId,
            salespersonId: data.salespersonId,
        });
    }
    setFormTaxCode(data: TaxCodeBus) {
        this.editForm.patchValue({
            taxCode: data
        });
    }
    customCustomerChanged() {
        if (this.customerId == CommonValues.CustomerId_PartsSales) {
            this.editForm.patchValue({
                accountClassId: CommonValues.AccountClass_PartSales
            });
        }
    }

    get saveMode_AR(): any {
        return this.ARAutomation ? this.saveModeAfterId : this.saveMode;
    }
    editBtn() {
        this.edit();
        if (this.ARAutomation && !this.hasId) {
            this.save();
        }
    }
    get childCanEdit(): boolean {
        let canEdit: boolean = this.canEdit && this.isValid && this.serviceMode !== "1" && ((this.saveMode == SaveMode.individual || !this.readOnly));
        if (this.ARAutomation) {
            canEdit = canEdit && this.hasId;
        }
        return canEdit;
    }
    get canSave(): boolean {
        let okToSave: boolean = false;
        if (this.isDirty || (this.ARAutomation && !this.hasId)) {
            if (this.isDirty) {
                okToSave = this.editForm.valid && this.customFormValidation() && this.appSaveValidation();
            }
            else {
                okToSave = this.editForm.valid && this.customFormValidation() && this.appSaveValidation();
            }
        }
        okToSave = okToSave && !this.anyLoadingsOn && !this.isSaving;
        return okToSave;
    }
    get enableSaveButton(): boolean {
        let enable: boolean = this.canSaveValue;
        if (this.ARAutomation) {
        }
        return enable;
    }
    canRecalculate = true;
    setupCheckFormLocal() {
        this.canRecalculate = (this.childCanEdit && this.data?.invoiceStatusId != CommonValues.Invoice_ReadyToPost && this.data?.invoiceStatusId != CommonValues.Invoice_WaitingForPayment);
    }
    editOff() {
        if (this.ARAutomation) {
            if (!this.hasId) {
                this.readOnly = true;
            }
        }
        else {
            super.editOff();
        }
    }
    get saveTooltip(): string {
        if (!this.ARAutomation || this.hasId)
            return "Saving is disabled because either required fields are not filled out or there is nothing to save.";
        else {

        }
    }
    get ARAutomation(): boolean {
        let hasArAutomation: boolean = false;

        if (this.hasReferenceData) {
            hasArAutomation = this.referenceData.ARInvoiceCreation == 1 && !this.isConstruction ? true : false;
        }
        return hasArAutomation;
    }
    get editButtonToolTip(): string {
        let toolTip: string = "Edit Invoice";
        if (this.ARAutomation) {
            toolTip = "Save Initial Calculated Invoice and Allow Edit";
        }
        return toolTip;
    }
    get showEditButton(): boolean {
        return !this.ARAutomation ? this.readOnly : !this.hasId;
    }
    customParentMessage(e: Message) {
        if (e.messageType === MessageType.taxCodeLoaderOff) {
            this.taxCodeLoading = false;
            this.setFormFlags();
        }
        else if (e.messageType === MessageType.changedCM) {
            if (this.hasData && CommonFunctions.hasValue(this.invoiceDisputeCMTabComponent)) {
                let cmParam: CommonParam = this.invoiceDisputeCMTabComponent.getDataForSave();
                this.data.creditMemoReasonCodeId = cmParam.getParam("CreditMemoReasonCodeId");
                this.data.creditMemoAmount = cmParam.getParam("CreditMemoAmount");
                this.data.creditMemoReason = cmParam.getParam("CreditMemoReason");
                this.data.creditMemoStatusId = cmParam.getParam("CreditMemoStatusId");
                this.data.creditMemoRejectedReason = cmParam.getParam("CreditMemoRejectedReason");
                this.invoiceDisputeCMCollTabComponent.setup();
            }

        }
    }
    get isCreditMemo(): boolean {
        return this.hasEditForm &&
            CommonFunctions.stringContains(this.editForm.get("invoiceNumber").value, "CR")
            || CommonFunctions.stringContains(this.editForm.get("invoiceNumber").value, "CORR")
            ? true : false;
    }
    get currentStatusWFPPlus(): boolean {
        return this.hasData
            && (this.data.invoiceStatusId == CommonValues.Invoice_WaitingForPayment
                || this.data.invoiceStatusId == CommonValues.Invoice_Completed
                || this.data.invoiceStatusId == CommonValues.Invoice_ReadyToPost
            )
            ? true : false;
    }
    get hasStatus(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.invoiceStatusId);
    }
    get accountClassId(): any {
        return this.hasAccountClass ? this.editForm.value.accountClassId : null;
    }

    get hasAccountClass(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.accountClassId);
    }
    get hasSalesperson(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.salespersonId);
    }
    get hasTerm(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.termId);
    }
    get hasTaxCode(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.taxCodeId);
    }
    get hasInvoiceDate(): boolean {
        return this.hasEditForm && DateFunctions.isValidDate(this.editForm.value.invoiceDate);
    }
    get hasDispatch(): boolean {
        return (this.hasData && CommonFunctions.hasGuidValue(this.data.dispatchId)) || (this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.dispatchId));
    }
    get hasQuote(): boolean {
        return this.hasData && CommonFunctions.hasGuidValue(this.data.quoteId);
    }

    get amount(): number {
        return this.hasData ? this.editForm.value.amount : 0;
    }
    get originalAmount(): number {
        return CommonFunctions.hasValue(this.originalData) ? this.originalData.amount : 0;
    }
    get PONumber(): string {
        return this.hasData ? this.editForm.value.ponumber : "";
    }
    get hasPONumber(): boolean {
        return CommonFunctions.hasStringValue(this.PONumber);
    }
    get OriginalPONumber(): string {
        return CommonFunctions.hasValue(this.originalData) ? this.originalData.ponumber : "";
    }
    get POOverrideUserId(): string {
        return this.hasData ? this.data.pooverrideUserId : null;
    }
    get hasPOOverrideUserId(): boolean {
        return CommonFunctions.hasGuidValue(this.POOverrideUserId);
    }
    get canEditPayments(): boolean {
        return true;
    }
    get canSetSpcApprvd(): boolean {
        return this.hasAddtlData && this.addtlData.canSetSpcApprvdIfFtr === true && this.rights.SetToApproved_Conditionally === true ? true : false;
    }
    checkedPONumber: string;
    override trySave() {
        if (this.isSaving) { return; }
        this.isSaving = true;
        if (this.hasPONumber && this.PONumber !== this.OriginalPONumber && this.PONumber !== this.checkedPONumber) {
            this.mainLoadingOn(true, this.compLoader);
            let checkDup_PO: boolean = false;
            this.appState = CommonAppStates.checkingToSave;
            this.checkForDuplictePO(this.PONumber);
        }
        else {
            super.trySave(this.compLoader);
            //            this.save();
        }
    }
    canSaveChildren(): BaseMessageInfo {
        let msgInfo = super.canSaveChildren();
        if (!this.invoiceLineItemsComponent.hasValidTaxCode || (this.invoiceLineItemsComponent.isEditing && !this.invoiceLineItemsComponent.canSaveForm)) {
            let msg: MessageInfo = this.invoiceLineItemsComponent.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        return msgInfo;
    }
    refresh() {
        if (!this.refreshToken || this.refreshToken == 0) {
            this.refreshToken = 1;
        }
        //this.mainTab
        let tempId = this.id;
        this.id = undefined;
        this.cd.detectChanges();
        this.id = tempId;
        this.getDataFromId(this.id);
        this.getData();
        this.pageData.clear();
        this.refreshData(null);
        this.refreshToken = 0;
        if (this.pageData.hasRelatedInvoices) {
            this.pageData.getRelatedInvoices(this.data.invoiceId);
        }
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.code === "DUP_PO") {
            if (data.dialogResult === CPDialogResult.ok) {
                this.checkedPONumber = this.PONumber;
                this.editForm.patchValue({
                    pooverrideUserId: this.globals.userId
                });
                if (this.appState === CommonAppStates.checkingToSave) {
                    this.save();
                }
            }
            else { //cancel
                this.editForm.patchValue({
                    ponumber: ""
                });
            }
        }
        else if (data.code === "SELINV") {
            this.goTo(data.data, SearchTarget.invoice, "GOTONEWDQOI");
        }

        else if (data.code === "DUP_INV") {
            if (data.dialogResult === CPDialogResult.ok) {
                this.duplicateInvoice();
            }
            else { //cancel
            }
        }
        else if (data.code === "DISP_CMREQ") {
            if (data.dialogResult === CPDialogResult.ok) {
                this.disputeStatusShow();
            }
            else {
                if (this.currentStatusWFPPlus) {
                    this.disputeStatus_Save(2);
                }
            }
        }
    }
    disputeStatusShow() {
        this.disputeStatusActive = true;
        this.invoiceDisputeCMComponent.setup();
    }
    disputeStatusHide(e: CommonParam) {
        if (e) {
            this.data.creditMemoReasonCodeId = e.getParam("CreditMemoReasonCodeId");
            this.data.creditMemoAmount = e.getParam("CreditMemoAmount");
            this.data.creditMemoReason = e.getParam("CreditMemoReason");
            this.data.creditMemoRejectedReason = e.getParam("CreditMemoRejectedReason");
            this.data.creditMemoStatusId = e.getParam("CreditMemoStatusId");
            if (CommonFunctions.hasValue(this.invoiceDisputeCMTabComponent)) {
                this.invoiceDisputeCMTabComponent.setup();
            }
            if (CommonFunctions.hasValue(this.invoiceDisputeCMCollTabComponent)) {
                this.invoiceDisputeCMCollTabComponent.setup();
            }
            if (this.currentStatusWFPPlus) {
                this.disputeStatus_Save(2);
            }
        }
        this.disputeStatusActive = false;
    }

    disputeStatusActive: boolean = false;
    disputeStatusValueChange(e: any) {
        if (e == 1) {
            setTimeout(() => {
                this.dispActiveCollNote = true;
            });
        }
        else if (e == 2) {
            this.cnfShow("Credit Memo Needed?", CRUDActions.None, null, "Dispute Resolved", "DISP_CMREQ", false, true);
        }
    }
    get sageCust(): string {
        return "Oracle Customer Id " + (this.hasAddtlData && CommonFunctions.hasValue(this.addtlData.detail) ? this.addtlData.detail.sageCust : "");
    }
    get collectionNoteSaveMode(): any {
        return SaveMode.individual;
    }
    subs_createDrawHO: Subscription;
    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_createDrawHO);
        CommonFunctions.unsubscribe(this.subs_updateInvoiceForTesting);
    }
    subs_setNewDefaults: Subscription;
    setNewDefaults() {
        super.setNewDefaults();
        this.setShowDispatchNumberOnLineItems(this.data.dispatchId, this.data.accountClassId);
    }
    setShowDispatchNumberOnLineItems(jobDispId: any, accountClassId: any) {
        let param: CommonParam = new CommonParam();
        param.addParam("JobNumber", '');
        param.addParam("JobId", jobDispId);
        param.addParam("AccountClassId", accountClassId);

        CommonFunctions.unsubscribe(this.subs_setNewDefaults);
        this.subs_setNewDefaults = this.svc_data.invoiceLineShowDispatch(param).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.data.showDispatchNumberOnLineItems = info.primaryReturn == true ? true : false;
                this.editForm.patchValue({
                    showDispatchNumberOnLineItems: this.data.showDispatchNumberOnLineItems
                });
            }
        });
    }
    checkListActive: boolean = false;
    isCheckListSucceed: boolean = false;
    doCheckList() {
        this.checkListActive = true;
        let params = [];
        let id: any = CommonFunctions.hasGuidValue(this.id) ? this.id : CommonValues.Guid_Empty;
        params.push(id);
        params.push(this.customerId);
        params.push(this.locationGeoInfo?.stateProvince ?? '');
        this.invoiceChecklistComponent.setup(params);
    }

    loadCheckList() {
        let params = [];
        let id: any = CommonFunctions.hasGuidValue(this.id) ? this.id : CommonValues.Guid_Empty;
        params.push(id);
        params.push(this.customerId);
        params.push(this.locationGeoInfo?.stateProvince ?? '');
        this.invoiceChecklistComponent.setup(params);
    }
    checkListClosed(e: any) {
        if (e) {
            this.setDirty();
            if (this.compFeatureFlagSet.featureFlagSet['check-customer-screen-invoice-checklist']) {
                this.InvoiceChecklist = this.invoiceChecklistComponent.getGridData();
                //Check if checkListt passed and set flags
                this.isCheckListSucceed = this.checkforIncompleteCheckList(this.id, this.customerId);
                if (this.isCheckListSucceed && this.originalData.invoiceStatusId == CommonValues.Invoice_Pending) {
                    this.editForm.patchValue({
                        invoiceStatusId: this.originalData.invoiceStatusId
                    });
                }
            }
        } else {
            this.isCheckListSucceed = this.checkforIncompleteCheckList(this.id, this.customerId);
            if (this.originalData.invoiceStatusId == CommonValues.Invoice_Pending) {
                this.editForm.patchValue({
                    invoiceStatusId: this.originalData.invoiceStatusId
                });
            }
        }
        this.checkListActive = false;
    }
    scheduleInvoicesActive: boolean = false;
    scheduleInvoicesClosed(e: any) {
        this.scheduleInvoicesActive = false;
    }
    scheduleInvoices() {
        this.scheduleInvoicesComponent.setup(null);
        this.scheduleInvoicesActive = true;
    }
    invoicePaymentsActive: boolean = false;
    invoicePaymentsClosed(e: any) {
        this.invoicePaymentsActive = false;
        if (e) {
            this.getAddtlData();
        }
    }
    invoicePayments() {
        this.invoicePaymentsComponent.setup(this.id);
        this.invoicePaymentsActive = true;
    }

    duplicateInvoice() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_dataDuplicateInvoice);
        this.subs_dataDuplicateInvoice = this.svc_data.duplicateInvoice(this.data.invoiceId).subscribe((info: BaseMessageInfo) => {
            //            alert(info.message + " => " + info.primaryReturn);
            this.compLoader.cpLoaderOff();
            if (!info.saveError) {
                this.cnfDialog.show("New Invoice #: " + info.primaryReturn, CRUDActions.None, null, "Invoice Successfully Duplicated", null, true);
            } else {
                this.saveError("There was Problem DUPLICATING the invoice " + info.message);
            }
        });
    }

    confirmDupInvoice() {
        this.cnfDialog.show("Are you sure you want to duplicate this invoice?", CRUDActions.None, null, "Are You Sure?", 'DUP_INV', false);
    }

    createDrawWithHeaderOnly() {
        this.compLoader.cpLoaderOn(true);
        CommonFunctions.unsubscribe(this.subs_createDrawHO);
        let dispatchId: string = '';
        if (this.data.accountClassId == CommonValues.AccountClass_WarrantyConstruction || this.data.accountClassId == CommonValues.AccountClass_WarrantyMFG) {
            dispatchId = this.data.dispatchId;
        } else {
            dispatchId = this.masterId;
        }

        this.subs_createDrawHO = this.svc_dqoi.createDrawWithHeaderOnly(this.masterId, dispatchId).subscribe((info: InvoiceMessageInfo) => {
            this.compLoader.cpLoaderOff();
            this.goTo(info, SearchTarget.invoice, "CRFROMDRAW");
        });
    }

    taxCodeCBOChanged(e: GItem) {
        let id: any = e ? e.value : null;
        this.setTaxCode(id);
        if (id == CommonValues.AvalaraExempt_TaxCode || id == CommonValues.AvalaraSTExemptUTMaterials_TaxCode) {
            this.globals.notifyWarning("To use this code, please email the current tax exemption certificate to statetax@climatepros.com.", true);
        }
    }

    setTaxCodeData(taxCode: TaxCodeBus) {
        this.isFetchFromAvalaraLabel = false;
        this.isAvalaraTaxCodeInfo = false;
        this.data.setTaxCode(taxCode);
        this.setFormTaxCode(this.data.taxCode);
        if (taxCode.taxCodeId === CommonValues.Avalara_TaxCode) {
            this.isFetchFromAvalaraLabel = true;
            this.isAvalaraTaxCodeInfo = true;
            this.getAvalaraTaxRate(this.id);
        } else if (taxCode.taxCodeId == CommonValues.AvalaraExempt_TaxCode || taxCode.taxCodeId == CommonValues.AvalaraSTExemptUTMaterials_TaxCode) {
            this.isFetchFromAvalaraLabel = true;
        }
    }

    subs_getTaxCode: Subscription;
    taxCodeLoading: boolean = false;
    setTaxCode(id: any, taxCodeLoading: boolean = false) {
        if (id) {
            this.taxCodeLoading = taxCodeLoading;
            this.setFormFlags();
            CommonFunctions.unsubscribe(this.subs_getTaxCode);
            this.subs_getTaxCode = this.svc_data.getTaxCode(id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    if (this.hasLocationDetail || this.hasData) {
                        this.setTaxCodeData(info.primaryReturn);
                    }
                }
                else {
                    this.data.setTaxCode(null);
                    this.setFormTaxCode(this.data.taxCode);
                }
            });
        }
        else {
            this.data.setTaxCode(null);
        }
    }
    get balanceDue(): number {
        return this.hasData && this.hasAddtlData ? this.data.total - this.addtlData.amountReceived : 0;
    }

    getAddtlData() {
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        this.addtlDataLoader = true;
        this.cd.detectChanges();
        this.subs_dataAddInfo = this.svc_data.getAdditionalData(this.id).subscribe(data => {
            this.loadAddtlData(data);
        });
    }
    

    private loadAddtlData(data: any): void {
        this.addtlData = new AdditionalInvoiceData(data);
        this.isWarranty = this.addtlData.isWarranty;
        this.invoiceLineItemsComponent.avalaraTaxAmount = this.addtlData.detail.taxAmount;
        this.setFormAddtl();
        this.setAddtlData();

        if (this.addtlData.lineItems.length > 0) {
            let interval = setInterval(() => {
                this.setTotalSummary(interval);
            }, 1000);
        }
        this.addtlDataLoader = false;
        this.cd.detectChanges();

        this.loadCheckList();

        let intervalCheck = setInterval(() => {
            try {
                this.isCheckListSucceed = this.checkforIncompleteCheckList(this.id, this.customerId);
            } catch (e) {
                console.error(e);
                clearInterval(intervalCheck);
            }
        }, 3000);
    }

    setTotalSummary(interval: NodeJS.Timeout): void {
        try {
            let liTotalsSummaryObj: InvoiceBus = this.invoiceLineItemsComponent.getCurrentTotals();
            this.data.cost = liTotalsSummaryObj.cost ? liTotalsSummaryObj.cost : this.data.cost;
            this.data.costLabor = liTotalsSummaryObj.costLabor ? liTotalsSummaryObj.costLabor : this.data.costLabor;
            this.data.costMaterial = liTotalsSummaryObj.costMaterial ? liTotalsSummaryObj.costMaterial : this.data.costMaterial;
            this.data.costOther = liTotalsSummaryObj.costOther ? liTotalsSummaryObj.costOther : this.data.costOther;
            this.data.saleLabor = liTotalsSummaryObj.saleLabor ? liTotalsSummaryObj.saleLabor : this.data.saleLabor;
            this.data.saleMaterial = liTotalsSummaryObj.saleMaterial ? liTotalsSummaryObj.saleMaterial : this.data.saleMaterial;
            this.data.saleOther = liTotalsSummaryObj.saleOther ? liTotalsSummaryObj.saleOther : this.data.saleOther;

            this.data.total = liTotalsSummaryObj.total || liTotalsSummaryObj.total != this.data.total ? liTotalsSummaryObj.total : this.data.total;
            this.data.amount = liTotalsSummaryObj.amount || liTotalsSummaryObj.amount != this.data.amount ? liTotalsSummaryObj.amount : this.data.amount;

            if (this.data.taxCode?.isAvalara === false) {
                this.data.taxAmount = liTotalsSummaryObj.taxAmount ? liTotalsSummaryObj.taxAmount : this.data.taxAmount;
            }

            this.setFormTotalSummary();
            this.getProfit();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            clearInterval(interval);
        }
    }

    print() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_print);

        if (this.compFeatureFlagSet.featureFlagSet['ui-enable-invoice-generator'] && (!this.compFeatureFlagSet.featureFlagSet['ui-enable-construction-old-invoice-pdf'] || !this.isConstruction)) {
            this.subs_print = this.svc_data.printUsingIronPdf(this.id).subscribe((data: PdfResponse) => {
                if(CommonFunctions.hasValue(data) && !data.hasErrors) {
                        this.printPdfDoc(data);
                    }
                    else {
                        this.notifyError("- A pdf of Invoice " + this.data.invoiceNumber + " could not be generated.");
                    }
                    this.compLoader.cpLoaderOff();
            },
            (error) => {
                this.handleError(error);
            });
        } else {
            this.subs_print = this.svc_data.print(this.id).subscribe((data: CDocument) => {
                this.printDocs(data);
            });
        }
    }

    //deprecated via ui-enable-invoice-generator
    printDocs(data: CDocument) {

        if (this.hasReferenceData) {
            let text: string = this.referenceData.getLocationDesc(this.data.locationId);
            CommonFunctions.copyToClipboard(text + " Invoice");
        }

        this.printService.printPdf(data);
        this.compLoader.cpLoaderOff();
        if (this.data.invoiceStatusId !== CommonValues.Invoice_Completed && this.data.invoiceStatusId !== CommonValues.Invoice_Canceled
            && this.data.invoiceStatusId !== CommonValues.Invoice_WaitingForPayment) {
            this.svc_dqoi.getDispatchStatus(this.data.dispatchId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError && info.primaryReturn == CommonValues.Dispatch_ReadyForBilling) {
                    this.data.setDispatchStatusToBilled = true;
                    this.save();
                }
            });
        }
    }

    //new printDocs for IronPdf
    printPdfDoc(data: PdfResponse) {
        if (this.hasReferenceData) {
            let text: string = this.referenceData.getLocationDesc(this.data.locationId);
            CommonFunctions.copyToClipboard(text + " Invoice");
        }

        let fileName = this.customer + "_" + this.location + "_" + this.data.invoiceNumber + "_" + this.data.wonumber + ".pdf";

        this.printService.printIronPdf(data, CommonFunctions.sanitizeSpecialCharacters(fileName));

        //do not do this for zuggit sales orders
        if (this.data.invoiceStatusId !== CommonValues.Invoice_Completed && this.data.invoiceStatusId !== CommonValues.Invoice_Canceled
            && this.data.invoiceStatusId !== CommonValues.Invoice_WaitingForPayment && !this.globals.user.isZuggitUser) {            
            this.svc_dqoi.getDispatchStatus(this.data.dispatchId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError && info.primaryReturn == CommonValues.Dispatch_ReadyForBilling) {
                    this.data.setDispatchStatusToBilled = true;
                    this.save();
                }
            });
        }
    }

    document: CDocument;
    mergeDocs() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_dataMergedDocs);
        this.subs_dataMergedDocs = this.svc_data.mergeDocs(this.id).subscribe(
            {
                next:
                    data => {
                        if (data.fileName) {
                            this.printService.printPdf(data);
                            this.compLoader.cpLoaderOff();
                        }
                        else {
                            this.compLoader.cpLoaderOff();
                            this.notifyError(" Merging Documents. Please review your Attachments");
                        }
                    },
                error: e => {
                    console.error(e);
                    this.globals.notifyError(`Unable to merge documents. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                    this.compLoader.cpLoaderOff();
                }
            });
    }
    setAddtlData() {
        this.billToAddress = new Address(this.addtlData.billingAddress);
        this.billToAddress.locationName = this.addtlData.detail.locationName;
        if (this.hasData && (!this.data.hasTaxCode || !this.data.taxCode.hasTaxLines)) {
            this.setTaxCode(this.data.taxCodeId, true);
        }
    }
    setForSave(): InvoiceBus {
        let now: Date = DateFunctions.getDateNow();
        let busObj: InvoiceBus = new InvoiceBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.billingGeographyInfo = this.billToGeoInfoComp.getData();
        busObj.shippingGeographyInfo = this.locGeoInfoComp.getData();
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.setBeforeSave();
        return busObj;
    }
    saveIndividual() {
        let busObj: InvoiceBus = this.setForSave();
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_save);
        this.subs_save = this.svc_data.savePrimary(this.globals.userId, busObj).subscribe((data: InvoiceInfo) => {
            this.mainLoadingOff(true, this.compLoader);
            if (!data.saveError) {
                this.data = _.cloneDeep(data.invoice);
                this.originalData = _.cloneDeep(this.data);
                this.saveSuccess();
            }
            else {
                this.saveError(data.message);
            }
        });
        this.readOnly = true;
    }
    saveAll() {

        this.mainLoadingOn(true, this.compLoader);

        let busSaveObj: InvoiceBus = this.setForSave();
        let busObj: InvoiceSaveParam = new InvoiceSaveParam(busSaveObj);
        busObj.constructionCreditType = ConstructionCredits.None;

        const isCRCORR = this.constructionCreditMemoCheck(ConstructionCredits.CreditMemoAndCorrection, true);
        if (isCRCORR && this.constructionCreditObject.hasSavedCreditMemo) {
            busObj.invoiceNumber = this.constructionCreditObject.creditMemoInvoiceNumber.replace("CR", "CORR");
        }

        //This is determining if constructionCreditMemoCheck is !== ConstructionCredits.None. Which is controlled by the false parameter.
        //So this determines if the CreditMemoCheck is NOT none
        if (this.constructionCreditMemoCheck(ConstructionCredits.None, false)) {

            this.addtlData.lineItems.forEach(x => {
                x.invoiceNumber = busObj.invoiceNumber;
                x.invoiceLineId = null;
                x.invoiceId = null;
            });

            this.id = null;
            busObj.isAdded = true;

            //if it's a CRCORR then initial save as the CR and then will save as CORR once we have the new CR#
            busObj.constructionCreditType = !this.constructionCreditObject.hasSavedCreditMemo
                ? ConstructionCredits.CreditMemoOnly : ConstructionCredits.CreditMemoAndCorrection;
            busObj.lineItems = this.addtlData.lineItems;

        } else {
            busObj.lineItems = _.cloneDeep(this.invoiceLineItemsComponent.getChanged());
            busObj.addDeletedItems(this.invoiceLineItemsComponent.getDeletedItems());
        }

        //Get sum object from line items grid and set parent object
        let calcTotals = false;
        if (this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]) {
            calcTotals = this.constructionCreditMemoCheck(ConstructionCredits.None, true) && CommonFunctions.hasArrayElementValue(busObj.lineItems) || !this.hasId;
        } else {
            calcTotals = CommonFunctions.hasArrayElementValue(busObj.lineItems) || !this.hasId;
        }

        if (calcTotals) {
            let liTotalsObj: InvoiceBus = this.invoiceLineItemsComponent.getCurrentTotals();
            busObj.cost = liTotalsObj.cost;
            busObj.costLabor = liTotalsObj.costLabor;
            busObj.costMaterial = liTotalsObj.costMaterial;
            busObj.costOther = liTotalsObj.costOther;
            busObj.saleLabor = liTotalsObj.saleLabor;
            busObj.saleMaterial = liTotalsObj.saleMaterial;
            busObj.saleOther = liTotalsObj.saleOther;
            busObj.total = liTotalsObj.total;
            if (this.data.taxCode?.isAvalara === false) {
                busObj.taxAmount = liTotalsObj.taxAmount;
            }
            busObj.amount = liTotalsObj.amount;
        }

        if (CommonFunctions.hasValue(this.invoiceNotesComponent)) {
            busObj.notes = _.cloneDeep(this.invoiceNotesComponent.getChanged());
            busObj.addDeletedItems(this.invoiceNotesComponent.getDeletedItems());
        }
        else {
            if (this.hasAddtlData && this.addtlData.notes) {
                let dataObjs = this.addtlData.notes.filter(s => s.isAdded === true || s.isUpdated === true);
                busObj.notes = InvoiceNoteBus.getDataObjsFromViewObjs(dataObjs);
            }
        }

        if (CommonFunctions.hasValue(this.invoiceAttachmentsComponent)) {
            busObj.attachments = _.cloneDeep(this.invoiceAttachmentsComponent.getChanged());
            busObj.addDeletedItems(this.invoiceAttachmentsComponent.getDeletedItems());
        }

        if (CommonFunctions.hasValue(this.invoiceEquipmentComponent)) {
            busObj.invoiceEquipment = _.cloneDeep(this.invoiceEquipmentComponent.getChanged());
            busObj.addDeletedItems(this.invoiceEquipmentComponent.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.collectionNotesComponent)) {
            busObj.collectionNotes = _.cloneDeep(this.collectionNotesComponent.getChanged());
            busObj.addDeletedItems(this.collectionNotesComponent.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.collectionNoteDispComponent)) {
            let dispCollNotes = _.cloneDeep(this.collectionNoteDispComponent.getChanged());
            if (CommonFunctions.hasArrayElementValue(dispCollNotes)) {
                if (!CommonFunctions.hasValue(busObj.collectionNotes)) {
                    busObj.collectionNotes = [];
                }
                busObj.collectionNotes.push(dispCollNotes[0]);
            }
        }
        if (busObj.isDraw) {
            busObj.drawPartsIds = this.addtlData.drawPartsIds;
        }
        if (CommonFunctions.hasValue(this.invoiceChecklistComponent)) {
            busObj.checkList = this.invoiceChecklistComponent.getGridData();
        }
        if (CommonFunctions.hasValue(this.invoiceDisputeCMTabComponent)) {
            let cmParam: CommonParam = this.invoiceDisputeCMTabComponent.getDataForSave();
            busObj.creditMemoReasonCodeId = cmParam.getParam("CreditMemoReasonCodeId");
            busObj.creditMemoAmount = cmParam.getParam("CreditMemoAmount");
            busObj.creditMemoReason = cmParam.getParam("CreditMemoReason");
            busObj.creditMemoRejectedReason = cmParam.getParam("CreditMemoRejectedReason");
            busObj.creditMemoStatusId = cmParam.getParam("CreditMemoStatusId");
            if (busObj.creditMemoStatusId == CommonValues.InvoiceCreditMemoStatusId_Rejected && (this.data.creditMemoStatusId !== busObj.creditMemoStatusId || busObj.disputeStatus == 2)) {
                busObj.disputeStatus = 1;
            }
        }
        CommonFunctions.unsubscribe(this.subs_save);

        if (this.isConstruction) {
            if (this.isWarranty) {
                busObj.isProgressBilling = true;
                busObj.isWarranty = true;
            }
        }

        const gatewaySubmitDateBeforeSave = DateFunctions.getUtcDate(this.data?.gatewaySubmitDate)?.getTime();
        this.subs_save = this.svc_data.saveAll(busObj).subscribe(
            {
                next: (info: InvoiceMessageInfo) => {
                    if (info.invoice) {
                        this.id = info.invoice.invoiceId;
                    }
                    if ((!info.errorCode || info.errorCode === InvoiceErrorCode.InitialSaveError) && info.saveError) {
                        if (this.constructionCreditMemoCheck(ConstructionCredits.None, false)) {
                            this.cancel();
                        }
                        this.mainLoadingOff(true, this.compLoader);
                        this.globals.notifyError("Failed to save changes, please try again. If problem continues contact an admin: " + info.message, true);
                    } else if ((info.errorCode && info.errorCode === InvoiceErrorCode.PartialSuccess) && info.saveError) {
                        const partialSaveMessage = info.message?.toLowerCase().includes('gateway submission failed')
                            ? info.message
                            : "Partial save has been made. The full save process failed and only some data was saved: " + info.message;
                        this.globals.notifyError(partialSaveMessage, true);
                        this.refresh();
                    }
                    else if ((!info.errorCode || info.errorCode === InvoiceErrorCode.InitialSaveError)) {
                        //Now create the Correction
                        const isCreditMemoAndCorrection = this.constructionCreditMemoCheck(ConstructionCredits.CreditMemoAndCorrection, true);
                        if (isCreditMemoAndCorrection && !this.constructionCreditObject.hasSavedCreditMemo) {
                            this.constructionCreditObject.hasSavedCreditMemo = true;
                            this.constructionCreditObject.creditMemoInvoiceNumber = info.invoice.invoiceNumber;
                            this.constructionCreditObject.reloadInvoiceId = info.invoice.invoiceId;
                            this.resetDataForCorrection();
                            return;
                        } else if (isCreditMemoAndCorrection && this.constructionCreditObject.hasSavedCreditMemo) {
                            this.constructionCreditObject = { ...this.defaultConstructionCreditObject };
                        } else {
                            this.constructionCreditObject = { ...this.defaultConstructionCreditObject };
                        }
                        //Must reset gridData to prevent duplicates
                        if (this.compFeatureFlagSet.featureFlagSet['ui-enable-invoice-checklist-duplication-fix']) {
                            this.invoiceChecklistComponent.clear();
                        }

                        this.resetMasterList = true;
                        let setDispatchStatusToBilled: boolean = this.data.setDispatchStatusToBilled;
                        this.refresh();
                        if (info.warning == true) {
                            this.globals.notifyWarning("Successfully Saved as 'Needs Approval' - " + info.message, true);
                        }
                        else if (this.compFeatureFlagSet.featureFlagSet['avalara-tax-error-address-status'] && info.invoice.isAvalaraError) {
                            this.globals.notifyError("There was a problem with Avalara: " + info.message, true);
                        }
                        else {
                            this.saveSuccess();
                            const savedGatewaySubmitDate = DateFunctions.getUtcDate(info.invoice?.gatewaySubmitDate);
                            if (DateFunctions.isValidDate(savedGatewaySubmitDate) && savedGatewaySubmitDate.getTime() !== gatewaySubmitDateBeforeSave) {
                                this.globals.notifyInfo("Invoice submitted to API Gateway. The final vendor status will update when the gateway callback returns.");
                            }
                        }
                        if (!this.isConstruction && setDispatchStatusToBilled) {
                            this.sendRefreshMessage(SearchTarget.dispatch, AppCategory.None);
                        }
                        if (this.ARAutomation) {
                            this.edit();
                        }
                        this.mainLoadingOff(true, this.compLoader);
                    }
                    this.isSaving = false;
                }, error: ((error) => {
                    console.error(error);
                    this.isSaving = false;
                    this.mainLoadingOff(true, this.compLoader);
                    const errorMessage = error?.error?.message || error?.message || 'Unable to save invoice. Please retry after refreshing the page.';
                    this.globals.notifyError(errorMessage, true);
                }),

            });
    }

    customFormValidation() {
        let canSave: boolean = super.customFormValidation();
        return canSave && CommonFunctions.hasGuidValue(this.editForm.value.invoiceStatusId)
            && (!this.hasId || CommonFunctions.hasStringValueLength(this.editForm.value.invoiceNumber, 7));
    }
    get anyLoadingsOn(): boolean {
        return this.mainDataLoading || this.addtlDataLoader || this.taxCodeLoading;
    }

    getData() {
        super.getData();
    }

    getDataFromId(id: any) {
        if (!CommonFunctions.hasGuidValue(id)) {
            return;
        }
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.get(id).subscribe((data: InvoiceBus) => {
            this.loadData(data);
            this.mainLoadingOff(true, this.compLoader);
        });
    }

    private resetDataForCorrection(): void {
        this.data = this.constructionCreditObject.data;
        this.addtlData = this.constructionCreditObject.addtlData;
        this.updateFormFieldsForConstructionCredits();
        this.saveAll(); //saving Correction (xxxCORR##)
    }

    private loadData(data: any): void {
        if (data !== null) {
            this.isWarranty = data.isWarranty;
            this.callMainLoaderOffAfterSetData = true;
            this.setDataCompLoader = this.compLoader;
            this.id = data.invoiceId;
            this.setData(data);
            this.getData();
            if (this.tabSelected === 'Credit Memos') {
                this.reloadCreditMemos();
            }
            this.getAvalaraTaxStatus(this.id);
            this.sortInventoryLocations(this.data.locationId);
            if (this.compFeatureFlagSet.featureFlagSet['check-customer-screen-invoice-checklist']) {
                this.isCheckListSucceed = this.checkforIncompleteCheckList(data.invoiceId, data.customerId);
            }
            this.inOracleError = (this.data?.invoiceStatusId == CommonValues.Invoice_OracleException);
        }
        else {
            this.mainLoadingOff(true, this.compLoader);
        }
    }

    checkforIncompleteCheckList(invoiceId: string, customerId: string): boolean {
        this.InvoiceChecklist = this.invoiceChecklistComponent.getGridData();
        if (this.InvoiceChecklist) {
            var checkedItemCount: number = this.InvoiceChecklist.filter(x => x.isChecked && !x.readOnly).length;
            var allrequiredItemCount: number = this.InvoiceChecklist.filter(x => !x.readOnly).length;
        }
        else {
            return false;
        }

        // Return true if lengths are not equal, false otherwise
        return allrequiredItemCount !== checkedItemCount;
    }
    getDataFromNumber(number: string) {
        if (!CommonFunctions.hasStringValue(number)) {
            return;
        }
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.getFromNumber(number).subscribe((data: InvoiceBus) => {
            if (data !== null) {
                this.id = data.invoiceId;
                this.setData(data);
                this.getData();
            }
            this.mainLoadingOff(true, this.compLoader);
        });
    }
    protected resetData(dqoiItem: DQOIItem) {
        super.resetData(dqoiItem);
        if (dqoiItem.hasInvoiceId) {
            this.getDataFromId(dqoiItem.invoiceId);
            this.count = dqoiItem.invoiceCount;
        }
    }
    setDQOIState() {
        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            item.invoiceId = this.data.invoiceId;
            if (!this.settingFromDQOIState) {
                item.customerId = this.data.customerId;
                item.locationId = this.data.locationId;
            }
            this.svc_dqoi.setDQOIItem(item);
        }
    }
    getStatusHist() {
        if (!this.pageData.hasStatusHistory && this.hasId) {
            this.pageData.getStatusHistory(this.data.invoiceId);
        }
    }

    checkListActivated: boolean = false;
    valueStatusChange(value: any, editForm: UntypedFormGroup, ctl: any) {

        if (this.originalData.invoiceStatusId != CommonValues.Invoice_Pending) {
            this.checkListActivated = false;
        }
        if (value == CommonValues.Invoice_TaxError_Status) {
            var msg: string = "Invoices cannot manually be placed in tax error status. Please choose another invoice status.";
            this.cnfShowSomeGeneralMessage(msg, "Status Change Error");
            editForm.patchValue({
                invoiceStatusId: this.originalData.invoiceStatusId
            });
            return;
        }
        else if (value == CommonValues.Invoice_Completed && !this.isCreditMemo && !this.rights.FinancialLockOverride) {
            var msg: string = "You cannot set the status to Completed. This is done through an automated process";
            this.cnfShowSomeGeneralMessage(msg, "Status Change Error");
            editForm.patchValue({
                invoiceStatusId: this.originalData.invoiceStatusId
            });
        }
        else if (value == CommonValues.Invoice_WaitingForPayment) {
            var hasReadyToPost: boolean = this.pageData.statusHistory.some(x => x.statusId == CommonValues.Invoice_ReadyToPost);
            if (!hasReadyToPost) {
                var msg: string = "You cannot set the status to waiting for payment since it has never been set to ready to post.";
                this.cnfShowSomeGeneralMessage(msg, "Status Change Error");
                editForm.patchValue({
                    invoiceStatusId: this.originalData.invoiceStatusId
                });
            }
        }
        else if (value == CommonValues.Invoice_ReadyToPost && !this.hasDispatch) {
            var msg: string = "You cannot set the status to Ready To Post because there is no Dispatch Connected to this Invoice.";
            this.cnfShowSomeGeneralMessage(msg, "Status Change Error");
            editForm.patchValue({
                invoiceStatusId: this.originalData.invoiceStatusId
            });
        }
        else if ((value != this.originalData.invoiceStatusId && this.originalData.invoiceStatusId == CommonValues.Invoice_Pending) && !this.rights.SkipInvoiceChecklist) {
            if (this.compFeatureFlagSet.featureFlagSet['check-customer-screen-invoice-checklist']) {
                if (this.checkforIncompleteCheckList(this.id, this.customerId)) {
                    this.checkListActivated = true;
                    //Popup the checklist if all the Read-Only values are not selected.
                    this.doCheckList();
                }
            }
        }
        else if (value == CommonValues.Invoice_ReadyToPost || value == CommonValues.Invoice_Approved || value == CommonValues.Invoice_ApprovedWithChanges) {
            let wasApproved = this.pageData.wasEverStatus(CommonValues.Invoice_Approved) && this.amount === this.originalAmount;
            var acctClass = editForm.get('accountClassId').value;
            if (acctClass == CommonValues.AccountClass_HVACService || acctClass == CommonValues.AccountClass_ReferService) {
                var profitPercent = CommonFunctions.calculateProfitPct(this.data.cost, this.data.total);
                var minProfit = this.addtlData.minProfit;
                if (profitPercent < minProfit && !wasApproved) {//canSetSpcApprvd
                    var overrideUserId = editForm.get('minProfitOverrideUserId').value;

                    var status = "ready to post";
                    if (value == CommonValues.Invoice_Approved) status = "approved";
                    else if (value == CommonValues.Invoice_ApprovedWithChanges) status = "approved with changes";
                    if ((this.rights.MinimumProfitOverrideApproval || (this.canSetSpcApprvd && this.rights.SetToApproved_Conditionally)) && !overrideUserId) {
                        // prompt user if want to save yes or no{
                        var msg: string = "Invoice profit percentage is below the " + this.customer + "'s minimum profit percentage. Would you like to approve setting the invoice to " + status + "?";
                        let result: boolean = confirm(msg);
                        if (result) {
                            editForm.patchValue({
                                minProfitOverrideUserId: this.globals.userId
                                , minProfitOverrideDt: DateFunctions.getDateNow()
                            });
                        }
                        else {
                            editForm.patchValue({
                                invoiceStatusId: this.originalData.invoiceStatusId
                            });
                        }
                    }
                    else if (!this.rights.MinimumProfitOverrideApproval && !overrideUserId) {
                        var msg: string = "You cannot set the invoice to " + status + " because the profit percentage is less than " + this.customer + "'s minimum profit percentage.";
                        alert(msg);
                        editForm.patchValue({
                            invoiceStatusId: this.originalData.invoiceStatusId
                        });
                    }
                }
            }
            if (!this.isConstruction && value === CommonValues.Invoice_Approved) {
                this.data.setDispatchStatusToBilled = true;
            }
        }
    }
    get canEdit(): boolean {
        let can: boolean = false;

        if ((this.hasId || (this.hasData && this.data.isAdded))) {
            if ((this.data.invoiceStatusId == CommonValues.Invoice_WaitingForPayment || this.data.invoiceStatusId == CommonValues.Invoice_Completed || this.data.invoiceStatusId == CommonValues.Invoice_OraclePending)) {
                if (this.rights.EditPostedInvoice) {
                    can = true;
                }
            }
            else if (this.data.invoiceStatusId == CommonValues.Invoice_ReadyToPost) {
                if (this.rights.EditReadyToPost) {
                    can = true;
                }
            } else if (this.rights.MaintainInvoices) {
                can = true;
            }
        }

        return can;
    }
    cantSaveMsg() {
        this.cnfShowSomeGeneralMessage("test");
    }
    canEditDate(): boolean {
        let can: boolean = false;
        if (!this.readOnly && this.rights.EditInvoiceDate) {
            can = true;
        }
        return can;
    }
    createNew(busObj: InvoiceBus) {
        return new InvoiceBus(busObj);
    }
    delete() {
        if (this.data.isAdded) {
            this.clear();
        }
        else {
            this.mainLoadingOn(true, this.compLoader);
            CommonFunctions.unsubscribe(this.subs_delete);
            this.subs_delete = this.svc_data.deleteInvoice(this.id).subscribe((info: BaseMessageInfo) => {
                this.mainLoadingOff(true, this.compLoader);
                if (!info.saveError) {
                    this.deleteSuccess();
                    this.clear();
                }
                else {
                    this.deleteError(info.message);
                }
            });
        }
    }
    get canDelete(): boolean {
        return (this.hasId || (this.hasData && this.data.isAdded)) && this.rights.DeleteInvoice;
    }
    result: any;
    afterDataSet() {
        this.customerChanged(this.data.customerId);
        this.setBillToGeoInfo(this.data.billingGeographyInfo);
        this.setLocationGeoInfo(this.data.shippingGeographyInfo);
        if (this.hasId && !this.isAdded) {
            this.refreshDQOIItem(this.id);
        }
    }
    checkCustomerChangeValid() {
        if (this.hasReferenceData && (this.hasEditForm || this.hasData) && this.hasAccountClass && !this.fullContract && this.accountClassId == CommonValues.AccountClass_Contract) {
            this.data.accountClassId = null;
            this.setControlValue("accountClassId", null, false);
        }
    }
    checkLocationChangeValid() {
        if (this.hasReferenceData && (this.hasEditForm || this.hasData) && this.hasAccountClass && !this.fullContract && this.accountClassId == CommonValues.AccountClass_Contract) {
            this.data.accountClassId = null;
            this.setControlValue("accountClassId", null, false);
        }
    }
    billToChanged(e: GItem) {
        CommonFunctions.unsubscribe(this.subs_geographyAddressBillTo);
        this.subs_geographyAddressBillTo = this.svc_customer.getGeographyAddress(e.value).subscribe((data: Address) => {
            this.billToAddress = new Address(data);
            this.billToAddress.locationName = e.description;
        });
    }
    panelExpand(e: any) {
        if (e === 'DOC' && !this.pageData.hasAttachments) {
            this.pageData.getAttachments(this.data.invoiceId);
        }
    }
    onTabSelect(e: SelectEvent) {
        this.tabSelected = e.title;
        if (e.title === 'Equipment' && !this.pageData.hasInvoiceEquipment) {
            this.pageData.getInvoiceEquipment(this.data.invoiceId);
        }
        if (e.title === 'Collection Notes' && !this.pageData.hasCollectionNotes) {
            this.pageData.getCollectionNotes(this.data.invoiceId);
            this.invoiceDisputeCMCollTabComponent.setup();
            if (!this.pageData.hasRelatedInvoices) {
                this.pageData.getRelatedInvoices(this.data.invoiceId);
            }
        }
        if (e.title === 'Status History' && !this.pageData.hasStatusHistory) {
            this.pageData.getStatusHistory(this.data.invoiceId);
        }
        if (e.title === 'Attachments' && !this.pageData.hasAttachments) {
            this.pageData.getAttachments(this.data.invoiceId);
        }
        if (e.title === 'Credit Memos') {
            this.reloadCreditMemos();
        }

    }

    reloadCreditMemos() {
        if (this.invoiceDisputeCMTabComponent) {
            this.invoiceDisputeCMTabComponent.setup();
            this.invoiceDisputeCMTabComponent.readOnly = this.readOnly;
            if (!this.pageData.hasRelatedInvoices) {
                this.pageData.getRelatedInvoices(this.data.invoiceId);
            }
        }
        if (this.invoiceDisputeCMCollTabComponent) {
            this.invoiceDisputeCMCollTabComponent.setup();
        }
    }

    locationChanged(id: any) {
        if (CommonFunctions.hasValue(id)) {
            CommonFunctions.unsubscribe(this.subs_locationDefaults);
            let dispatchId = this.svc_dqoi.getDQOIItem(this.dqoiIndex).dispatchId;
            dispatchId = CommonFunctions.hasGuidValue(dispatchId) ? dispatchId : CommonValues.Guid_Empty;
            if (dispatchId == CommonValues.Guid_Empty) {
                dispatchId = this.data.dispatchId;
            }

            let isFromDraw: boolean = this.code === "CRFROMDRAW" ? true : false;
            this.subs_locationDefaults = this.svc_data.getInvoiceDefaultsFromLocation(id, dispatchId, isFromDraw).subscribe((data: v_LocationDetailBus) => {
                this.locationDetail = new v_LocationDetailBus(data);
                let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
                locGeoInfo.set(data.geographyId, data.locationName, data.addressLine1, data.addressLine2, data.city, data.stateProvince, data.countryCd, data.county, data.postalCode);
                let billToGeoInfo: GeographyInfoBus = new GeographyInfoBus();
                billToGeoInfo.set(data.billingGeographyId, data.billingAddressName, data.billingAddressLine1, data.billingAddressLine2, data.billingCity, data.billingStateProvince, data.countryCd, data.billingCounty, data.billingPostalCode);
                this.laborInventoryLocationIds = data.laborInventoryLocationIds;
                this.divisionInventoryLocationId = data.inventoryLocationId;
                this.invoiceLineItemsComponent.setInventoryLocationList(this.laborInventoryLocationIds, this.divisionInventoryLocationId);
                this.setLocationGeoInfo(locGeoInfo);
                this.setBillToGeoInfo(billToGeoInfo);
                this.data.setTaxCode(data.taxCode);
                this.setFormTaxCode(data.taxCode);
                this.setFormLocation(data);
                this.checkLocationChangeValid();
            });
        }
        else {
            let data: v_LocationDetailBus = new v_LocationDetailBus(null);
            let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            this.setLocationGeoInfo(locGeoInfo);
            this.setBillToGeoInfo(locGeoInfo);
            this.setFormLocation(data);
            this.data.setTaxCode(data.taxCode);
            this.setFormTaxCode(data.taxCode);
        }
    }

    resendOracle() {
        this.inOracleError = false;
        this.mainLoadingOn(true, this.compLoader);
        this.subs_statusUpdate = this.svc_data.updateInvoiceStatus(this.id, CommonValues.Invoice_ReadyToPost).subscribe((data: any) => {
            this.subs_resendOracle = this.svc_data.resendOracle(this.id).subscribe((data: any) => {
                this.mainLoadingOff(true, this.compLoader);
                this.refresh();
            });            
        });

    }

    sortInventoryLocations(id: any) {
        if (CommonFunctions.hasValue(id)) {
            CommonFunctions.unsubscribe(this.subs_locationDefaults);
            let dispatchId = this.svc_dqoi.getDQOIItem(this.dqoiIndex).dispatchId;
            dispatchId = CommonFunctions.hasGuidValue(dispatchId) ? dispatchId : CommonValues.Guid_Empty;
            if (dispatchId == CommonValues.Guid_Empty) {
                dispatchId = this.data.dispatchId;
            }

            this.subs_locationDefaults = this.svc_data.getInvoiceDefaultsFromLocation(id, dispatchId, false).subscribe((data: v_LocationDetailBus) => {
                if (!data) {
                    this.laborInventoryLocationIds = [];
                    this.divisionInventoryLocationId = data?.inventoryLocationId;
                    this.locationDetail = new v_LocationDetailBus();
                } else {
                    this.laborInventoryLocationIds = data.laborInventoryLocationIds;
                    this.divisionInventoryLocationId = data.inventoryLocationId;
                    this.locationDetail = new v_LocationDetailBus(data);
                }
                this.invoiceLineItemsComponent.setInventoryLocationList(this.laborInventoryLocationIds, this.divisionInventoryLocationId);
            });
        }
    }

    locationChangedNoTax(id: any) {
        if (CommonFunctions.hasValue(id)) {
            CommonFunctions.unsubscribe(this.subs_locationDefaults);
            let dispatchId = this.svc_dqoi.getDQOIItem(this.dqoiIndex).dispatchId;
            dispatchId = CommonFunctions.hasGuidValue(dispatchId) ? dispatchId : CommonValues.Guid_Empty;
            this.subs_locationDefaults = this.svc_data.getInvoiceDefaultsFromLocation(id, dispatchId).subscribe((data: v_LocationDetailBus) => {
                this.locationDetail = new v_LocationDetailBus(data);
                let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
                locGeoInfo.set(data.geographyId, data.locationName, data.addressLine1, data.addressLine2, data.city, data.stateProvince, data.countryCd, data.county, data.postalCode);
                let billToGeoInfo: GeographyInfoBus = new GeographyInfoBus();
                billToGeoInfo.set(data.billingGeographyId, data.billingAddressName, data.billingAddressLine1, data.billingAddressLine2, data.billingCity, data.billingStateProvince, data.countryCd, data.billingCounty, data.billingPostalCode);
                this.setLocationGeoInfo(locGeoInfo);
                this.setBillToGeoInfo(billToGeoInfo);
                this.laborInventoryLocationIds = data.laborInventoryLocationIds;
                this.divisionInventoryLocationId = data.inventoryLocationId;
                this.invoiceLineItemsComponent.setInventoryLocationList(this.laborInventoryLocationIds, this.divisionInventoryLocationId);
                this.setFormLocationNoTax(data);
                this.checkLocationChangeValid();
            });
        }
        else {
            let data: v_LocationDetailBus = new v_LocationDetailBus(null);
            let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            this.setLocationGeoInfo(locGeoInfo);
            this.setBillToGeoInfo(locGeoInfo);
            this.setFormLocation(data);
            this.data.setTaxCode(data.taxCode);
            this.setFormTaxCode(data.taxCode);
        }
    }
    setCustomerLocation(customerId: any, locationId: any) {
        this.data.customerId = customerId;
        this.data.locationId = locationId;
        super.setCustomerLocation(customerId, locationId);
    }

    code: string = '';
    setup(data: any, code: string = null) {
        this.code = code;
        if (code === 'CRFROMQUOTE') {
            this.saveMode = SaveMode.all;
            let dqoiParam: DQOIParam = data as DQOIParam;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.invoiceAdded = true;
            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);
            let info: InvoiceMessageInfo = dqoiParam.data as InvoiceMessageInfo;
            this.clear();
            //            this.getData();
            this.customerChanged(this.data.customerId);
            this.locationChanged(this.data.locationId);
            this.addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);
            this.pageData = new InvoicePage(this.svc_data, null, this.cd);

            var invoiceBus = new InvoiceBus(info.invoice);
            this.setData(invoiceBus);
            this.pageData.setEquipment(info.dcValues.equipment);
            this.setFormAddtl();
            this.edit();
            this.setDirty();
            this.setFormFlags();
        }
        else if (code == "CRFROMDISPATCH") {
            this.saveMode = SaveMode.all;
            let dqoiParam: DQOIParam = data as DQOIParam;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.invoiceAdded = true;
            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);

            let info: InvoiceMessageInfo = dqoiParam.data as InvoiceMessageInfo;
            if (info.warning) {
                this.miShow("Please Review and Correct/Acknowledge the list of Messages", info, info.invoice, "Warning Creating Invoice From Dispatch", "CRFROMDISPATCH");
            }
            this.clear();
            this.customerChanged(info.invoice.customerId);
            this.locationChangedNoTax(info.invoice.locationId);
            this.pageData = new InvoicePage(this.svc_data, null, this.cd);
            var invoiceBus = new InvoiceBus(info.invoice);
            this.setData(invoiceBus);
            this.setTaxCode(invoiceBus.taxCode.taxCodeId);
            this.data.setTaxCode(invoiceBus.taxCode);
            this.pageData.setEquipment(info.dcValues.equipment);
            this.addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);
            this.setFormAddtl();
            if (this.ARAutomation) {
                this.editOff();
            } else {
                this.edit();
                this.setDirty();
            }
            this.setFormFlags();
        }
        else if (code == "CRFROMORDERBILL") {
            this.saveMode = SaveMode.all;
            let dqoiParam: DQOIParam = data as DQOIParam;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.invoiceAdded = true;
            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);

            let info: InvoiceMessageInfo = dqoiParam.data as InvoiceMessageInfo;
            if (info.warning) {
                this.miShow("Please Review and Correct/Acknowledge the list of Messages", info, info.invoice, "Warning Creating Invoice From Dispatch", "CRFROMDISPATCH");
            }
            this.clear();
            this.customerChanged(info.invoice.customerId);
            this.locationChangedNoTax(info.invoice.locationId);
            this.pageData = new InvoicePage(this.svc_data, null, this.cd);
            var invoiceBus = new InvoiceBus(info.invoice);
            this.setData(invoiceBus);
            this.setTaxCode(invoiceBus.taxCode.taxCodeId);
            this.data.setTaxCode(invoiceBus.taxCode);
            this.pageData.setEquipment(info.dcValues.equipment);
            this.addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);
            this.setFormAddtl();
            if (this.ARAutomation) {
                this.editOff();
            } else {
                this.edit();
                this.setDirty();
            }
            this.setFormFlags();
        }
        else if (code == "CRFROMDISPATCHRECALCULATE") {
            this.saveMode = SaveMode.all;

            let dqoiParam: DQOIParam = data as DQOIParam;
            let info: InvoiceMessageInfo = dqoiParam.data as InvoiceMessageInfo;
            this.addtlData.updateLines(info.dcValues.addtlData);
            this.setFormAddtl();
            if (this.ARAutomation) {
                this.editOff();
            } else {
                this.edit();
                this.setDirty();
            }
            this.setFormFlags();
        }
        else if (code === "CRFROMDRAW" || code == "CRFROMJOB") {
            this.saveMode = SaveMode.all;
            let dqoiParam: DQOIParam = data as DQOIParam;
            dqoiParam.dqoiItem.invoiceNumber = null;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.invoiceAdded = true;
            dqoiParam.dqoiItem.invoiceStatusName = null;
            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);

            let info: InvoiceMessageInfo = dqoiParam.data as InvoiceMessageInfo;
            if (info.warning) {
                this.miShow("Please Review and Correct/Acknowledge the list of Messages", info, info.invoice, "Warning Creating Draw", "CRFROMDISPATCH");
            }
            this.clear();
            this.customerChanged(info.invoice.customerId);
            this.locationChanged(info.invoice.locationId);
            this.addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);
            this.pageData = new InvoicePage(this.svc_data, null, this.cd);
            var invoiceBus = new InvoiceBus(info.invoice);
            this.setData(invoiceBus);
            this.setTaxCode(invoiceBus.taxCodeId);

            if (this.compFeatureFlagSet.featureFlagSet['construction-invoice-code-restrictions'] && this.isConstruction) {
                this.isWarranty = info.invoice.isWarranty;
            }
            this.pageData.setEquipment(info.dcValues.equipment);
            this.setFormAddtl();
            this.edit();
            this.setDirty();
            this.setFormFlags();

        }
        else if (code === "GOTO") {
            this.clear();
            this.getDataFromId(data.id);
        }
    }
    setTotalsFromLineItems() {
        let liTotalsObj: InvoiceBus = this.invoiceLineItemsComponent.getCurrentTotals();
        this.data.cost = liTotalsObj.cost;
        this.data.costLabor = liTotalsObj.costLabor;
        this.data.costMaterial = liTotalsObj.costMaterial;
        this.data.costOther = liTotalsObj.costOther;
        this.data.saleLabor = liTotalsObj.saleLabor;
        this.data.saleMaterial = liTotalsObj.saleMaterial;
        this.data.saleOther = liTotalsObj.saleOther;
        // Feature-flagged Avalara taxAmount preserve (ui-header-tax-calc).
        // Off = legacy always take taxAmount from line totals.
        // On = do not overwrite Avalara taxAmount with line recalculation.
        if (this.compFeatureFlagSet.featureFlagSet['ui-header-tax-calc']) {
            if (this.data.taxCode?.isAvalara !== true) {
                this.data.taxAmount = liTotalsObj.taxAmount;
            }
        } else {
            this.data.taxAmount = liTotalsObj.taxAmount;
        }
        this.data.total = liTotalsObj.total;
        this.data.amount = liTotalsObj.amount;
    }
    afterSetForm() {
        if (this.hasData) {
            this.setShowDispatchNumberOnLineItems(this.data.dispatchId, this.data.accountClassId);
        }
        this.taxCodesCanSelectAndCurrent(this.data.taxCodeId);
        this.blockStatusChange = (this.data.customerId == CommonValues.CustomerId_ClimatePros && !this.rights.ApproveClimateProsInvoice && this.data.invoiceStatusId==CommonValues.Invoice_NeedsApproval);
    }
    updateRefrigerantTracking() {
        if (this.hasEditForm && this.hasDispatch) {
            this.svc_data.dispatchRefTrackingNbr_Update(this.data.dispatchId, this.editForm.value.refTrackNbr).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.saveSuccess("Refrigerant Tracking Nbr: " + this.editForm.value.refTrackNbr + " Successfully Updated On Dispatch");
                }
                else {
                    this.saveError(info.message);
                }
            });
        }
    }
    setMasterId() {
        if (!CommonFunctions.hasValue(this._masterId)) {
            this._masterId = this.data.dispatchId;
        }
    }
    protected setNoData(item: DQOIItem) {
        if (CommonFunctions.hasValue(item)) {
            this._masterId = item.dispatchId;
            this.getListFromMaster();
        }
    }

    getListFromMaster() {
        this.masterListLoader = true;
        CommonFunctions.unsubscribe(this.subs_masterList);
        this.subs_masterList = this.svc_data.getListFromMaster(this.masterId).subscribe((info: BaseMessageInfo) => {
            this.masterList = info.primaryReturn;
            this.cloneMasterList();
            if (CommonFunctions.hasGuidValue(info.primaryId)) {
                this._masterId = info.primaryId;
            }
            this.masterListLoader = false;
            this.cd.detectChanges();
        });
    }
    checkForDuplictePO(PONumber: string) {
        let param: CommonParam = new CommonParam();
        param.addParam("PONumber", PONumber);
        param.addParam("InvoiceId", this.id);
        param.addParam("CustomerId", this.customerId);
        this.svc_data.checkForDuplicatePO(param).subscribe((info: InvoiceMessageInfo) => {
            if (info.duplicatePO == true) {
                this.cnfShow(info.message, CRUDActions.None, null, "PO Already Exists", "DUP_PO");
            }
            else {
                this.checkedPONumber = PONumber;
                if (this.appState === CommonAppStates.checkingToSave) {
                    super.trySave(this.compLoader);
                }
            }

        });
    }
    profit: Profit = new Profit();

    private getProfit() {
        if (!this.profit) {
            this.profit = new Profit();
        }
        let costPlusUseTax = this.getCostPlusUseTax();
        this.profit.dollar = CommonFunctions.calculateProfit(costPlusUseTax, this.data.amount);
        this.profit.percent = CommonFunctions.calculateProfitPct(costPlusUseTax, this.data.amount);
        this.profit.dollarDisplay = CommonFunctions.formatMoney(this.profit.dollar);
        if (this.profit.dollar && this.profit.dollar != 0) {
            this.profit.percentDisplay = CommonFunctions.formatPct(this.profit.percent);
        }
        else {
            this.profit.percentDisplay = "0.00%";
        }
    }
    accountClassCBOChanged(e: GItem) {
        if (CommonFunctions.hasGuidValue(e.value)) {
            if (!this.fullContract && e.value == CommonValues.AccountClass_Contract) {
                if (this.hasData) {
                    this.setControlValue("accountClassId", this.data.accountClassId, false);
                }
                else {
                    this.setControlValue("accountClassId", null, false);
                }
                this.cnfShow("You cannot change the Account Class to Contract because the Customer is not Full Contract", CRUDActions.None, null, "Account Class Change", "", true);
            }
        }
    }
    taxCodeShow() {
        this.taxCodeComponent.setup(this.data.taxCode);
        this.taxCodeActive = true;
    }
    taxCodeActive: boolean = false;
    taxCodeClosed(e: any) {
        this.taxCodeActive = false;
    }
    testCanEdit: boolean = false;
    test() {
        let profit = CommonFunctions.formatMoney(CommonFunctions.calculateProfit(this.data.cost, this.data.amount));
        let profitPct = CommonFunctions.formatPct(CommonFunctions.calculateProfitPct(this.data.cost, this.data.amount));
    }
    get dontRequireChangeCode(): boolean {
        let ret = false;
        if (this.hasReferenceData && this.hasCustomer) {
            ret = this.referenceData.customerDoesntRequireChangeCode(this.customerId) || this.isConstruction;
        }
        return ret;
    }
    get disableNewInvoiceSplitButton(): boolean {
        const invoiceNumber = (this.editForm?.get("invoiceNumber")?.value ?? '').toString().trim().toUpperCase();
        return !this.hasId || invoiceNumber.endsWith('C') || invoiceNumber.endsWith('W');
    }
    public iconClass: string = 'fas fa-file-plus';
    

    setNewButtonTypeData() {
        const invoiceNumber = this.editForm.get("invoiceNumber")?.value;
        if (!invoiceNumber) {
            this.setNewButtonTypeDataWithSplitState(false, false);
            return;
        }

        const invoiceNumbersToCheck: string[] = [invoiceNumber + 'C', invoiceNumber + 'W'];

        this.svc_data.checkInvoiceWithSuffix(invoiceNumbersToCheck).subscribe({
            next: (results: InvoiceNumberCheckResponse) => {
                if (results.hasErrors) {
                    this.notifyError('Failed to check invoice suffix availability. ' + results.errors.join(' '));
                    return;
                }
                const resultList = Array.isArray(results?.result) ? results.result : [];
                const contractExists = resultList.some(r => r.invoiceNumber === invoiceNumber + 'C' && r.exists === true);
                const warrantyExists = resultList.some(r => r.invoiceNumber === invoiceNumber + 'W' && r.exists === true);

                this.setNewButtonTypeDataWithSplitState(contractExists, warrantyExists);
            },
            error: (error: any) => {
                this.notifyError('Failed to check invoice suffix availability. ' + (error?.message ?? 'Please review server logs for details.'));
                this.setNewButtonTypeDataWithSplitState(false, false);
            }
        });
    }

    private setNewButtonTypeDataWithSplitState(contractExists: boolean, warrantyExists: boolean): void {
        if (this.invoiceDisputeValue == 1) {
            if (this.isConstruction) {
                this.createConstructionCreditMenuOptions();
            } else {
                this.newButtonTypeData = [
                    {
                        text: 'New',
                        iconClass: 'fa fa-shopping-cart',
                        code: "NEW",
                    }, {
                        text: 'Split to New Contract Invoice',
                        iconClass: 'fa fa-user',
                        code: "CON",
                        blocked: contractExists || warrantyExists,
                        tooltip: contractExists || warrantyExists ? 'Invoice Split Already Exists' : 'Split to New Contract Invoice'
                    }, {
                        text: 'Split to New Warranty Invoice',
                        iconClass: 'fa fa-wrench',
                        code: "WAR",
                        blocked: warrantyExists || contractExists,
                        tooltip: warrantyExists || contractExists ? 'Invoice Split Already Exists' : 'Split to New Warranty Invoice'
                    }, {
                        text: 'CR - Credit Memo Only',
                        iconClass: 'fa fa-wrench',
                        code: "CR"
                    }, {
                        text: 'CR/CORR - Credit Memo and Corrected Invoice',
                        iconClass: 'fa fa-wrench',
                        code: "CRCORR"
                    }, {
                        text: 'CR/CORR Multiple - Credit Memo and Multiple Corrected Invoices',
                        iconClass: 'fa fa-wrench',
                        code: "CRCORRM"
                    }
                ];
            }
        } else {
            if (this.isConstruction) {
                this.createConstructionCreditMenuOptions();
            } else {
                this.newButtonTypeData = [
                    {
                        text: 'New',
                        iconClass: 'fa fa-shopping-cart',
                        code: "NEW"
                    }, {
                        text: 'Split to New Contract Invoice',
                        iconClass: 'fa fa-user',
                        code: "CON",
                        blocked: contractExists || warrantyExists,
                        tooltip: contractExists || warrantyExists ? 'Invoice Split Already Exists' : 'Split to New Contract Invoice'
                    }, {
                        text: 'Split to New Warranty Invoice',
                        iconClass: 'fa fa-wrench',
                        code: "WAR",
                        blocked: warrantyExists || contractExists,
                        tooltip: warrantyExists || contractExists ? 'Invoice Split Already Exists' : 'Split to New Warranty Invoice'
                    }
                ];
            }
        }
    }
    public newButtonTypeData: Array<any> = [
        {
            text: 'New',
            iconClass: 'fa fa-shopping-cart',
            code: "NEW"
        }, {
            text: 'Split to New Contract Invoice',
            iconClass: 'fa fa-user',
            code: "CON"
        }, {
            text: 'Split to New Warranty Invoice',
            iconClass: 'fa fa-wrench',
            code: "WAR"
        }, {
            text: 'CR - Credit Memo Only',
            iconClass: 'fa fa-wrench',
            code: "CR"
        }, {
            text: 'CR/CORR - Credit Memo and Corrected Invoice',
            iconClass: 'fa fa-wrench',
            code: "CRCORR"
        }, {
            text: 'CR/CORR Multiple - Credit Memo and Multiple Corrected Invoices',
            iconClass: 'fa fa-wrench',
            code: "CRCORRM"
        }
    ];

    private createConstructionCreditMenuOptions(): void {
        this.newButtonTypeData = [
            {
                text: 'New Blank Draw',
                iconClass: 'fas fa-file-invoice-dollar',
                code: "NEW"
            },
            {
                text: 'Credit Memo Only',
                iconClass: 'fa fa-wrench',
                code: "CR",
                disabled: !this.hasCreateConstructionCreditsPermission && this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]
            }, {
                text: 'Credit Memo and Corrected Invoice',
                iconClass: 'fa fa-wrench',
                code: "CRCORR",
                disabled: !this.hasCreateConstructionCreditsPermission && this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]
            }
        ];
    }
    public isStatusItemDisabled = (itemArgs: { dataItem: GItem; index: number }): boolean => {
        return this.data.customerId == CommonValues.CustomerId_ClimatePros && itemArgs.dataItem.value == CommonValues.Invoice_Approved && !this.rights.ApproveClimateProsInvoice;
    };
    public onNewSplitButtonClick(event: any, dataItem: any): void {
        if (dataItem === undefined) {
            return;
        }

        if (dataItem.blocked) {
            event.preventDefault();
            event.stopPropagation();
            return;
        } else if (event.defaultPrevented) { 
            event.allowDefault();
            event.allowPropagation();
            return;
        }

        const code = dataItem?.code;
        if (code === "NEW") {
            if (this.isConstruction) {
                this.createDrawWithHeaderOnly();
            } else {
                this.new();
            }
        }
        if (code === "CON") {
            this.invCopyToNewShow("C");
        }
        else if (code === "WAR") {
            this.invCopyToNewShow("W");
        }
        else if (code === "CRCORRM") {
            this.invoiceCMCRCORRShow("M");
        }
        else if (code === "CRCORR") {

            if (this.isConstruction && this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]) {
                if (!this.hasCreateConstructionCreditsPermission) {
                    return;
                } else {
                    this.constructionCreditObject.constructionCreditType = ConstructionCredits.CreditMemoAndCorrection;
                    this.constructionCreditObject.data = _.cloneDeep(this.data);
                    this.constructionCreditObject.addtlData = _.cloneDeep(this.addtlData);
                    this.createCreditMemo();
                }
            } else {
                this.invoiceCMCRCORRShow("S");
            }

        }
        else if (code === "CR") {
            if (this.isConstruction && this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]) {
                if (!this.hasCreateConstructionCreditsPermission) {
                    return;
                } else {
                    this.constructionCreditObject.constructionCreditType = ConstructionCredits.CreditMemoOnly;
                    this.createCreditMemo();
                }
            } else {
                this.invoiceCMCRCORRShow("CR");
            }
        }
    }

    private createCreditMemo() {
        if (this.isConstruction && this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]) {

            this.updateAddtlDataForCreditMemoOnly();

            this.updateDataForCreditMemoOnly();

            this.updateFormFieldsForConstructionCredits();

            this.saveAll();
        }
    }

    private creditMemoMulitipler = -1;
    private updateDataForCreditMemoOnly(): void {
        let copy = _.cloneDeep(this.data);

        copy.total = copy.total * this.creditMemoMulitipler;
        copy.amount = copy.amount * this.creditMemoMulitipler;
        copy.taxAmount = copy.taxAmount > 0 ? copy.taxAmount * this.creditMemoMulitipler : copy.taxAmount;
        copy.saleOther = copy.saleOther > 0 ? copy.saleOther * this.creditMemoMulitipler : copy.saleOther;
        copy.saleMaterial = copy.saleMaterial > 0 ? copy.saleMaterial * this.creditMemoMulitipler : copy.saleMaterial;
        copy.saleLabor = copy.saleLabor > 0 ? copy.saleLabor * this.creditMemoMulitipler : copy.saleLabor;
        copy.costMaterial = copy.costMaterial > 0 ? copy.costMaterial * this.creditMemoMulitipler : copy.costMaterial;
        copy.costLabor = copy.costLabor > 0 ? copy.costLabor * this.creditMemoMulitipler : copy.costLabor;
        copy.costOther = copy.costOther > 0 ? copy.costOther * this.creditMemoMulitipler : copy.costOther;
        copy.cost = copy.cost > 0 ? copy.cost * this.creditMemoMulitipler : copy.cost;

        copy.useTax = copy.useTax > 0 ? copy.useTax * this.creditMemoMulitipler : copy.useTax;
        this.invoiceLineItemsComponent.avalaraTaxAmount = copy.taxAmount;
        this.data = copy;
    }

    private updateAddtlDataForCreditMemoOnly(): void {
        let copy = _.cloneDeep(this.addtlData.profit);
        copy.useTax = copy.useTax * this.creditMemoMulitipler;

        this.addtlData.profit = copy;
        this.addtlData.lineItemsSummary.totalTax = this.addtlData.lineItemsSummary.totalTax * this.creditMemoMulitipler;
        this.addtlData.lineItemsSummary.total = this.addtlData.lineItemsSummary.total * this.creditMemoMulitipler;

        this.addtlData.lineItems.forEach((x: any) => {
            x.markupCost = x.markupCost * this.creditMemoMulitipler;

            x.quantity = x.quantity * this.creditMemoMulitipler;
            x.amount = x.price * x.quantity;
            x.totalCost = x.totalCost > 0 ? x.totalCost * this.creditMemoMulitipler : x.totalCost;
            x.tax = x.tax > 0 ? x.tax * this.creditMemoMulitipler : x.tax;
            x.useTax = x.useTax > 0 ? x.useTax * this.creditMemoMulitipler : x.useTax;
            x.avalaraTaxCalculated = x.avalaraTaxCalculated && x.avalaraTaxCalculated > 0
                ? x.avalaraTaxCalculated * this.creditMemoMulitipler
                : x.avalaraTaxCalculated;
        });
    }

    private updateFormFieldsForConstructionCredits(): void {
        this.editForm.patchValue({
            invoiceStatusId: CommonValues.Invoice_Pending_Construction,
            amount: this.data.amount,
            total: this.data.total,
            taxAmount: this.data.taxAmount,
            useTax: this.data.useTax,
            saleOther: this.data.saleOther,
            saleMaterial: this.data.saleMaterial,
            saleLabor: this.data.saleLabor,
            costMaterial: this.data.costMaterial,
            costLabor: this.data.costLabor,
            costOther: this.data.costOther,
            cost: this.data.cost
        });
    }

    invCopyToNewActive: boolean = false;
    invCopyToNewClosed(e: any) {
        this.invCopyToNewHide();
        if (CommonFunctions.isGuid(e)) {
            let url: string = "/quickview/service/4/" + e;
            this.navigate(url);
        }
        if (e != false) {
            this.refresh();
        }
    }
    copyToNewTitle: string = "";
    invCopyToNewShow(code: string) {
        if (code === 'C' && !this.fullContract) {
            this.cnfShowSomeGeneralMessage("You cannot Split this Invoice to Contract", "Customer is NOT on Full Contract");
        }
        else {
            this.invCopyToNewActive = true;
            this.copyToNewTitle = "Copy Lines To New - " + (code === "W" ? "Warranty" : "Contract") + " Invoice";
            this.invCopyToNewComponent.setup({ "id": this.id, "code": code });
        }
    }
    invCopyToNewHide() {
        this.invCopyToNewActive = false;
    }

    invoiceCMCRActive: boolean = false;
    invoiceCMCRShow() {
        this.invoiceCMCRActive = true;
    }
    invoiceCMCRHide(e: any) {
        this.invoiceCMCRActive = false;
        if (e && this.hasId) {
            this.pageData.getRelatedInvoices(this.id);
            this.getListFromMaster();
        }
    }

    

    invoiceCMCRCORRCaption: string = "";
    invoiceCMCRCORRActive: boolean = false;
    invoiceCMCRCORRCode: string = "S";
    invoiceCMCRCORRShow(code: string = "S") {
        this.creditMemoCORRComponent.setup({ id: this.id, code: code });
        this.invoiceCMCRCORRCode = code;
        this.invoiceCMCRCORRActive = true;
        this.invoiceCMCRCORRCaption = "Invoice - Credit Memo";
        if (this.invoiceCMCRCORRCode === "S" || this.invoiceCMCRCORRCode === "M") {
            this.invoiceCMCRCORRCaption += " and Corrected Invoice";
            if (this.invoiceCMCRCORRCode === "M") {
                this.invoiceCMCRCORRCaption += "s";
            }
        }
    }
    invoiceCMCRCORRHide(e: any) {
        this.invoiceCMCRCORRCode = "S";
        this.invoiceCMCRCORRActive = false;
        if (e && this.hasId) {
            this.pageData.getRelatedInvoices(this.id);
            this.getListFromMaster();
        }
    }

    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
    }
    quotePickerActive: boolean = false;
    quotePickerClosed(e: any) {
        this.quotePickerActive = false;
    }

    showQuote(e) {

        this.quotePicker.setId(this.data.quoteId, this.data.dispatchId);
        this.quotePickerActive = true;

    }

    invoicePickerActive: boolean = false;
    invoicePickerClosed(e: any) {
        this.invoicePickerActive = false;
    }
    dropid: any;
    showDispatch(e) {

        this.invoicePicker.setId(this.data.dispatchId);
        this.invoicePickerActive = true;

    }
    parentdropEvent(e) {
        if (e.detailType == 1 || e.detailType == 2 || e.detailType == 3 || e.detailType == 5) {
            if (this.invoiceLineItemsComponent.canDrop()) {
                this.dropid = e.dropid;
                if (this.invoiceLineItemsComponent.insertRow()) {
                    var st = SearchTarget.dispatch;
                    var id = e.dispatchId;
                    if (e.detailSource == "Q") {
                        st = SearchTarget.quote;
                        id = e.quoteId;
                    }
                    this.svc_data.createInvoiceLineFrom(st, id, e.detailType, e.dropid).subscribe((info: InvoiceMessageInfo) => {
                        if (!info.saveError) {

                            var addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);

                            if (addtlData.lineItems && addtlData.lineItems.length > 0) {
                                this.invoiceLineItemsComponent.updateRow(addtlData.lineItems[0]);

                                this.invoiceLineItemsComponent.sumAggregates();
                                setTimeout(() => {
                                    this.invoiceLineItemsComponent.sumGrid();
                                    this.editForm.markAsDirty();
                                }, 500);
                            }
                        }

                    });
                }

            }
        }

        if (e.detailType == 4) {
            if (this.invoiceNotesComponent.canDrop()) {
                this.dropid = e.dropid;
                if (this.invoiceNotesComponent.insertRow()) {
                    var st = SearchTarget.dispatch;
                    var id = e.dispatchId;
                    if (e.detailSource == "Q") {
                        st = SearchTarget.quote;
                        id = e.quoteId;
                    }
                    this.svc_data.createInvoiceLineFrom(st, id, e.detailType, e.dropid).subscribe((info: InvoiceMessageInfo) => {
                        if (!info.saveError) {
                            var addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);

                            if (addtlData.notes && addtlData.notes.length > 0) {
                                addtlData.notes[0].invoiceId = this.id;
                                this.invoiceNotesComponent.updateRow(addtlData.notes[0]);
                                this.invoiceLineItemsComponent.sumAggregates();
                                setTimeout(() => {
                                    this.invoiceLineItemsComponent.sumGrid();
                                    this.editForm.markAsDirty();
                                }, 500);
                            }
                        }
                    });
                }
            }
        }
    }

    billingEmail() {
        this.svc_data.getEmailDefaultsForBilling(this.id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError && !info.warning) {
                let email: Email = new Email(info.primaryReturn);
                let strEmail: string = "mailto: " + email.to + " ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded();
                window.location.assign("mailto: " + email.to + " ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
            }
            else if (info.saveError) {
                this.saveError("Error Trying to Construct Email: " + info.message);

            }
            else {
                let email: Email = new Email(info.primaryReturn);
                window.location.assign("mailto: " + email.to + " ?subject=" + email.subjectEncoded() + "&body=");
            }

        });
    }
    get saveMode_dispute(): any {
        return this.currentStatusWFPPlus ? this.saveModeAfterId : this.saveMode;
    }

    dispActiveCollNote: boolean = false;
    dispActiveCollNoteClosed(e: any) {
        this.dispActiveCollNote = false;
        if (!e) {
            this.editForm.patchValue({
                disputeStatus: this.data.disputeStatus
            });
        }
        else {
            if (this.currentStatusWFPPlus) {
                this.disputeStatus_Save(1);
            }
        }
    }
    disputeStatus_Save(disputeStatus: number) {
        let param: CommonParam = new CommonParam();
        param.addParam("DisputeStatus", disputeStatus);
        this.svc_data.saveInvoiceDisputeStatus(this.id, param).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.globals.notifySuccess("Dispute Status " + CommonValues.Message_SuccessfullySaved);

            }
            this.setPristine();
        });
    }
    invoiceDisputeValue: number = 0;
    get InvoiceDispute(): number {
        let _InvoiceDispute: number = this.rights.InvoiceDisputes == true ? 1 : 0;
        return _InvoiceDispute;
    }
    newJob() {
        this.new();
        this.doDispatchSearch(null);
    }
    dispatchSearch: boolean = false;
    doDispatchSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.editForm.patchValue({
                dispatchNumber: null,
                dispatchId: null
            });
            this.setDirty();
        }
        else {
            this.dispatchSearch = true;
            this.CpSearchDispatchs.setSearchText(e);
        }
    }

    dispatchSelected(value: any) {
        this.dispatchSearch = false;
        if (value != null) {
            if (this.isConstruction) {
                this.editForm.patchValue({
                    customerId: value.CustomerId,
                    locationId: value.LocationId,
                    dispatchNumber: value.DispatchNumber,
                    dispatchId: value.DispatchId,
                    accountClassId: value.AccountClassId
                });
                this.setCustomerLocation(value.CustomerId, value.LocationId);
                this.setDirty();
            }
        }
    }
    dispatchValidationError(event: any) {

        this.dispatchSearch = true;
    }
    dispatchValidate(value: any) {
        var skipCheck = false;
        if (!value) {
            this.editForm.patchValue({
                dispatchNumber: value,
                dispatchId: null
            });
            skipCheck = true;
        }
        else {
            var dispatchId = this.editForm.controls["dispatchId"].value;
            var dispatchNumber = this.editForm.controls["dispatchNumber"].value;
            if (dispatchId) {
                if (dispatchNumber === value) { skipCheck = true; }
            }
        }

        if (!skipCheck) {
            this.dispatchSearch = false;
            this.CpSearchDispatchs.validate(value);
        }
    }

    getAvalaraTaxStatus(invoiceId: string) {
        this.svc_data.getAvalaraTaxStatus(invoiceId).subscribe((data: any) => {
            if (data !== null) {
                this.avalaraTaxStatus = data.avalaraTaxStatus == null ? '' : data.avalaraTaxStatus;
            }
        });
    }

    getAvalaraTaxRate(invoiceId: string) {
        if (!invoiceId) { //added to prevent error when calling api will null value
            return;
        }
        this.svc_data.getAvalaraTaxRate(invoiceId).subscribe((data: any) => {
            if (data.hasPrimaryReturn && this.data.taxCode) {
                this.data.taxCode.taxRate = data.primaryReturn;
                this.data.taxCode.isRetailTax = false;
                this.isFetchFromAvalaraLabel = false;
            }
        });
    }

    invoiceFromConstruction() {
        let param = {
            ContractID: this.data.dispatchId
        };
        this.svc_dqoi.canSelectAvalarST(param).subscribe((data) => {
            if (data) {
                let tracking = setInterval(() => {
                    this.editForm.patchValue({
                        taxCodeId: CommonValues.AvalaraSTExemptUTMaterials_TaxCode
                    });
                    clearInterval(tracking);
                }, 1000);
            }
        });
    }
    onBlur() {
        var blurValue = this.editForm.controls.amNote.value;
        const currentDateTime = new Date().toLocaleString('en-US');

        // Don't allow multiple audit stamps.  It could get ugly
        if (!this.aMNoteAdjusted) {
            this.editForm.patchValue({
                amNote: this.data.amNote = blurValue + ' - ' + this.globals.user.username + '-' + currentDateTime,
            });
            this.aMNoteAdjusted = true;
        }
    }
    recalculateInvoiceFromDispatch() {
        this.mainLoadingOn(true, this.compLoader);
        this.svc_dqoi.createNewInvoiceFrom(SearchTarget.dispatch, this.data.dispatchId).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {
                var deleteditems = this.invoiceLineItemsComponent.getDeletedItems();
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMDISPATCHRECALCULATE";
                param.data = info;
                this.setup(param, "CRFROMDISPATCHRECALCULATE");
                if (this.addtlData.lineItems.length > 0) {
                    let interval = setInterval(() => {
                        this.setTotalSummary(interval);
                        for (let e of deleteditems) {
                            this.invoiceLineItemsComponent.addDeletedItemGItem(e);
                        }
                        this.setDirty();
                        this.invoiceLineItemsComponent.setDataLoading(false);
                    }, 1000);
                }
            }
            else {
                this.globals.notifyError("Error Creating Invoice: " + info.message, true);
            }
            this.mainLoadingOff(true, this.compLoader);
        });
    }
    subs_updateInvoiceForTesting: Subscription;
    updateInvoiceForTesting() {
        CommonFunctions.unsubscribe(this.subs_updateInvoiceForTesting);
        this.subs_updateInvoiceForTesting = this.svc_data.updateInvoiceForTesting(this.id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.globals.notifySuccess("Successfully Updated Invoice for Testing!");
            }
        });
    }

    private constructionCreditMemoCheck(constructionCreditType: ConstructionCredits, uesEquality: boolean): boolean {
        let result = false;

        if (this.isConstruction && this.compFeatureFlagSet.featureFlagSet[`credit-memo-invoice-copy`]) {
            if (uesEquality) {
                result = this.constructionCreditObject.constructionCreditType === constructionCreditType;
            } else {
                result = this.constructionCreditObject.constructionCreditType !== constructionCreditType;
            }
        }
        return result;
    }

    private checkUserForConstructionCreditsPermission(): void {
        const uid = this.globals.userId;
        this.svc_auth.userFeatures(uid).subscribe(data => {
            if (data) {
                const x = data.find(x => x.value === CommonValues.Permission_CreateConstructionCredits);
                this.hasCreateConstructionCreditsPermission = CommonFunctions.hasValidValue(x);
            }
        });
    }

    handleError(error) {
        this.mainLoadingOff(true, this.compLoader);
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this.notifyError(errorMessage);
        return throwError(errorMessage);
    }
}
